define(["mobx-state-tree","jquery","underscore","@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons","polyglot","gemini/lib/@waca/dashboard-common/dist/core/APIFactory","gemini/lib/@waca/dashboard-common/dist/ui/AuthoringToolbar","gemini/lib/@waca/dashboard-common/dist/utils/ActionTypes","gemini/lib/@waca/dashboard-common/dist/utils/MemUtil","dashboard-analytics/DynamicFileLoader","gemini/lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI"], function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_73__, __WEBPACK_EXTERNAL_MODULE_74__, __WEBPACK_EXTERNAL_MODULE_75__, __WEBPACK_EXTERNAL_MODULE_79__, __WEBPACK_EXTERNAL_MODULE_82__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _VisSlotEditorResources = __webpack_require__(12);

var _VisSlotEditorResources2 = _interopRequireDefault(_VisSlotEditorResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Polyglot = __webpack_require__(13);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisSlotEditorResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	_createClass(StringResources, [{
		key: 'get',
		value: function get(key, interpolationOptions) {
			return this.polyglot.t(key, interpolationOptions);
		}
	}]);

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Gets the number of filter items
 * @param {object} localFilter the filter applied.
 * @return the number of filter items applied. If filter number is not applicable, return null
 */
var getNumberOfFilterItems = exports.getNumberOfFilterItems = function getNumberOfFilterItems(localFilter) {
	if (localFilter) {
		if (localFilter.operator === 'in' || localFilter.operator === 'notin' || localFilter.operator === 'isnull') {
			return localFilter.values.length;
		}
	}
	return null;
};

// Scrollable drag constants
var SCROLL_DRAG_DISTANCE = 20;
var handleScroll = exports.handleScroll = function handleScroll(e, scrollableContainer, onScrollCallback) {
	var boundingRect = scrollableContainer.getBoundingClientRect();
	var rect = {
		top: boundingRect.top,
		bottom: boundingRect.bottom
	};
	if (e.type === 'touchmove') {
		var coords = e.touches[0];
		if (coords) {
			e.clientX = coords.clientX;
			e.clientY = coords.clientY;
		}
	}
	if (!e.clientX || !e.clientY) {
		return;
	}
	var position = {
		x: e.clientX,
		y: e.clientY
	};
	var distanceBottom = rect.bottom - position.y;
	var distanceTop = position.y - rect.top;
	var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
	var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
	var distanceY = 0;
	if (isScrollingTop && isScrollingBottom) {
		isScrollingTop = distanceTop > distanceBottom;
		isScrollingBottom = !isScrollingTop;
	}
	if (isScrollingBottom) {
		distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
	} else if (isScrollingTop) {
		distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
	}
	var newScrollTop = scrollableContainer.scrollTop + distanceY;
	if (newScrollTop <= 0) {
		newScrollTop = 0;
	} else {
		var maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
		if (newScrollTop > maxScrollTop) {
			newScrollTop = maxScrollTop;
		}
	}
	if (scrollableContainer.scrollTop !== newScrollTop) {
		scrollableContainer.scrollTop = newScrollTop;
		if (onScrollCallback) {
			onScrollCallback();
		}
	}
};

/** this function returns datasource id that will be used in type in dropdown
 * it exercises following logic: 
 * 1. if there is active datasource id, use it
 * 2. else, use first datasource id in the list of datasources
 */
var getDataSourceIdTypeIn = exports.getDataSourceIdTypeIn = function getDataSourceIdTypeIn(dashboardApi) {
	var sourceId = dashboardApi.getActiveDataSourceId();
	if (!sourceId) {
		var dataSourceFeature = dashboardApi.getFeature('DataSources');
		if (dataSourceFeature.getDataSourceList().length > 0) {
			sourceId = dataSourceFeature.getDataSourceList()[0].getId();
		}
	}
	return sourceId;
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"localFilters":"Local filters","slotEditorMsg1":"Required field","slotEditorMsg2":"Drag and drop data to the fields above to build and filter the visualization.","missingColumn":"Missing: %{columnLabel}","placeholderDropzone":"Click or drag data here","slotEditor_emptyState_no_visualization_selected_title":"No visualization selected","slotEditor_emptyState_no_visualization_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_widget_not_support_slot_selected_title":"The widget selected does not use fields","slotEditor_emptyState_widget_not_support_slot_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_multiple_visualizations_selected_title":"Multiple widgets selected","slotEditor_emptyState_multiple_visualizations_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_visualization_has_error_title":"The visualization cannot be displayed","slotEditor_slotItem_tooltip":"Source:","slotEditor_emptyState_vis_not_created_title":"No visualization created","slotEditor_emptyState_vis_not_created_description":"Create a visualization to manage the field settings.","slotEditor":"Fields","slotEditorCoachMarkTitle":"Access fields","slotEditorCoachMarkContents":"Add columns to the fields to build and modify visualizations.","toolbarDeleteFilterActionText":"Remove filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filter bins","coachMarkTitleSpiralTarget":"Edit scope","coachMarkContentSpiralTarget":"This is where you can access and modify the driver selection for your target.","overlayDropZonePlaceHolderText":"Drag data here"},"__cs":{"localFilters":"Lokální filtry","slotEditorMsg1":"Povinné pole","slotEditorMsg2":"Přetáhněte data do polí nahoře, aby se sestavila a filtrovala vizualizace.","missingColumn":"Chybí: %{columnLabel}","placeholderDropzone":"Klepněte nebo přetáhněte data sem","slotEditor_emptyState_no_visualization_selected_title":"Není vybrána žádná vizualizace","slotEditor_emptyState_no_visualization_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Vybraný modul widget nepoužívá pole","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vícenásobný výběr modulů widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_visualization_has_error_title":"Vizualizaci nelze zobrazit","slotEditor_slotItem_tooltip":"Zdroj:","slotEditor_emptyState_vis_not_created_title":"Nebyla vytvořena žádná vizualizace","slotEditor_emptyState_vis_not_created_description":"Vytvořte vizualizaci pro správu nastavení polí.","slotEditor":"Pole","slotEditorCoachMarkTitle":"Přístupová pole","slotEditorCoachMarkContents":"Přidejte k polím sloupce, aby bylo možné sestavovat a upravovat vizualizace.","toolbarDeleteFilterActionText":"Odebrat filtr","toolbarActionFilter":"Filtr","filterAutobinActionText":"Filtrovat přihrádky","coachMarkTitleSpiralTarget":"Upravit rozsah","coachMarkContentSpiralTarget":"Zde je k dispozici přístup k výběru drivery pro cíl a možnost jeho úprav.","overlayDropZonePlaceHolderText":"Přetáhněte data sem"},"__da":{"localFilters":"Lokale filtre","slotEditorMsg1":"Påkrævet felt","slotEditorMsg2":"Træk og placér data til felterne ovenfor for at bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klik og træk data her","slotEditor_emptyState_no_visualization_selected_title":"Der er ikke valgt nogen visualisering","slotEditor_emptyState_no_visualization_selected_description":"Vælg en visualisering for at administrere feltindstillingerne.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widget anvender ikke felter","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vælg en visualisering for at administrere feltindstillingerne.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgetter er valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Vælg en visualisering for at administrere feltindstillingerne.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering er oprettet","slotEditor_emptyState_vis_not_created_description":"Opret en visualisering for at administrere feltindstillingerne.","slotEditor":"Felter","slotEditorCoachMarkTitle":"Anvend felter","slotEditorCoachMarkContents":"Tilføj kolonner til felterne for at bygge og ændre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrér","filterAutobinActionText":"Filtrér områder (bins)","coachMarkTitleSpiralTarget":"Redigér omfang","coachMarkContentSpiralTarget":"Her kan du få adgang til og ændre styreprogramvalget for dit mål.","overlayDropZonePlaceHolderText":"Træk data her"},"__de":{"localFilters":"Lokale Filter","slotEditorMsg1":"Erforderliches Feld","slotEditorMsg2":"Daten in die Felder oben ziehen und ablegen, um die Visualisierung zu erstellen und zu filtern.","missingColumn":"Nicht vorhanden: %{columnLabel}","placeholderDropzone":"Klicken oder Daten hierher ziehen","slotEditor_emptyState_no_visualization_selected_title":"Keine Visualisierung ausgewählt","slotEditor_emptyState_no_visualization_selected_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung auswählen.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Das ausgewählte Widget verwendet keine Felder.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung auswählen.","slotEditor_emptyState_multiple_visualizations_selected_title":"Mehrere Widgets ausgewählt","slotEditor_emptyState_multiple_visualizations_selected_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung auswählen.","slotEditor_emptyState_visualization_has_error_title":"Die Visualisierung kann nicht angezeigt werden.","slotEditor_slotItem_tooltip":"Quelle:","slotEditor_emptyState_vis_not_created_title":"Keine Visualisierung erstellt","slotEditor_emptyState_vis_not_created_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung erstellen.","slotEditor":"Felder","slotEditorCoachMarkTitle":"Felder aufrufen","slotEditorCoachMarkContents":"Spalten zu den Feldern hinzufügen, um Visualisierungen zu erstellen und zu ändern.","toolbarDeleteFilterActionText":"Filter entfernen","toolbarActionFilter":"Filtern","filterAutobinActionText":"Bins filtern","coachMarkTitleSpiralTarget":"Bereich bearbeiten","coachMarkContentSpiralTarget":"Hier können Sie auf die Auswahl der Einflussfaktoren für das Ziel zugreifen und gegebenenfalls Änderungen vornehmen.","overlayDropZonePlaceHolderText":"Daten hierher ziehen"},"__es":{"localFilters":"Filtros locales","slotEditorMsg1":"Campo necesario","slotEditorMsg2":"Arrastre y suelte los datos en los campos para crear y filtrar la visualización.","missingColumn":"Falta: %{columnLabel}","placeholderDropzone":"Pulse o arrastre los datos aquí","slotEditor_emptyState_no_visualization_selected_title":"No se ha seleccionado ninguna visualización","slotEditor_emptyState_no_visualization_selected_description":"Seleccione una visualización para gestionar los valores del campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"El widget seleccionado no utiliza campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Seleccione una visualización para gestionar los valores del campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Varios widgets seleccionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Seleccione una visualización para gestionar los valores del campo.","slotEditor_emptyState_visualization_has_error_title":"No se puede mostrar la visualización","slotEditor_slotItem_tooltip":"Origen:","slotEditor_emptyState_vis_not_created_title":"No se ha creado ninguna visualización","slotEditor_emptyState_vis_not_created_description":"Cree una visualización para editar las propiedades del campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acceso","slotEditorCoachMarkContents":"Añada columnas a los campos para crear y modificar las visualizaciones.","toolbarDeleteFilterActionText":"Eliminar filtro","toolbarActionFilter":"Filtro","filterAutobinActionText":"Filtrar cubetas","coachMarkTitleSpiralTarget":"Editar ámbito","coachMarkContentSpiralTarget":"Aquí puede acceder y modificar la selección de controlador de su destino.","overlayDropZonePlaceHolderText":"Arrastre los datos aquí"},"__fi":{"localFilters":"Paikalliset suodattimet","slotEditorMsg1":"Pakollinen kenttä","slotEditorMsg2":"Voit muodostaa visualisoinnin ja suodattaa sen vetämällä ja pudottamalla tiedot yllä oleviin kenttiin.","missingColumn":"Puuttuva: %{columnLabel}","placeholderDropzone":"Napsauta tätä, tai vedä tiedot tähän","slotEditor_emptyState_no_visualization_selected_title":"Visualisointia ei ole valittu","slotEditor_emptyState_no_visualization_selected_description":"Valitse visualisointi kentän asetusten hallintaa varten.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Valittu pienoisohjelma ei käytä kenttiä","slotEditor_emptyState_widget_not_support_slot_selected_description":"Valitse visualisointi kentän asetusten hallintaa varten.","slotEditor_emptyState_multiple_visualizations_selected_title":"Useita pienoisohjelmia valittu","slotEditor_emptyState_multiple_visualizations_selected_description":"Valitse visualisointi kentän asetusten hallintaa varten.","slotEditor_emptyState_visualization_has_error_title":"Visualisointia ei voi näyttää","slotEditor_slotItem_tooltip":"Lähde:","slotEditor_emptyState_vis_not_created_title":"Visualisointia ei ole luotu","slotEditor_emptyState_vis_not_created_description":"Luo visualisointi kentän asetusten hallintaa varten.","slotEditor":"Kentät","slotEditorCoachMarkTitle":"Kenttien käyttö","slotEditorCoachMarkContents":"Lisää kenttiin sarakkeita visualisointien muodostusta ja muuttamista varten.","toolbarDeleteFilterActionText":"Poista suodatin","toolbarActionFilter":"Suodatin","filterAutobinActionText":"Suodata numeroryhmät","coachMarkTitleSpiralTarget":"Muokkaa aluetta","coachMarkContentSpiralTarget":"Tässä voit käyttää ja muokata vaikuttimien valintaa kohdetta varten.","overlayDropZonePlaceHolderText":"Vedä tiedot tähän"},"__fr":{"localFilters":"Filtres locaux","slotEditorMsg1":"Zone requise","slotEditorMsg2":"Glissez-déposez des données sur les zones ci-dessus pour générer et filtrer la visualisation.","missingColumn":"Manquant : %{columnLabel}","placeholderDropzone":"Cliquez ou faites glisser les données ici","slotEditor_emptyState_no_visualization_selected_title":"Aucune visualisation sélectionnée","slotEditor_emptyState_no_visualization_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Le widget sélectionné n'utilise pas de zones","slotEditor_emptyState_widget_not_support_slot_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_multiple_visualizations_selected_title":"Plusieurs widgets sélectionnés","slotEditor_emptyState_multiple_visualizations_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_visualization_has_error_title":"Impossible d'afficher la visualisation","slotEditor_slotItem_tooltip":"Source :","slotEditor_emptyState_vis_not_created_title":"Aucune visualisation créée","slotEditor_emptyState_vis_not_created_description":"Créez une visualisation pour gérer les paramètres de zone.","slotEditor":"Zones","slotEditorCoachMarkTitle":"Accéder aux zones","slotEditorCoachMarkContents":"Ajoutez des colonnes aux zones pour générer et modifier les visualisations.","toolbarDeleteFilterActionText":"Retirer le filtre","toolbarActionFilter":"Filtre","filterAutobinActionText":"Filtrer les casiers","coachMarkTitleSpiralTarget":"Editer la portée","coachMarkContentSpiralTarget":"Vous pouvez accéder ici au pilote sélectionné pour votre cible et le modifier.","overlayDropZonePlaceHolderText":"Faites glisser les données ici"},"__hr":{"localFilters":"Lokalni filteri","slotEditorMsg1":"Obavezno polje","slotEditorMsg2":"Povucite podatke i ispustite ih na polja iznad da biste izgradili i filtrirali vizualizaciju.","missingColumn":"Nedostaje: %{columnLabel}","placeholderDropzone":"Kliknite ili povucite podatke ovdje","slotEditor_emptyState_no_visualization_selected_title":"Nema izabranih vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izabrani grafički element ne koristi polja","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izabrano je više grafičkih elemenata","slotEditor_emptyState_multiple_visualizations_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacija se ne može prikazati","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Nije kreirana vizualizacija","slotEditor_emptyState_vis_not_created_description":"Kreirajte vizualizaciju za upravljanje postavkama polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Pristup poljima","slotEditorCoachMarkContents":"Poljima dodajte stupce da izgradite i promijenite vizualizacije.","toolbarDeleteFilterActionText":"Ukloni filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Pregradci filtera","coachMarkTitleSpiralTarget":"Uređivanje opsega","coachMarkContentSpiralTarget":"Ovdje možete dohvatiti i promijeniti izbor pogonitelja za vaš cilj.","overlayDropZonePlaceHolderText":"Ovdje povucite podatke"},"__hu":{"localFilters":"Helyi szűrők","slotEditorMsg1":"Kötelező mező","slotEditorMsg2":"Húzza az adatokat a fenti mezőkre a megjelenítés összeállításához és szűréséhez.","missingColumn":"Hiányzik: %{columnLabel}","placeholderDropzone":"Kattintson vagy húzzon ide adatokat","slotEditor_emptyState_no_visualization_selected_title":"Nincs kijelölt megjelenítés","slotEditor_emptyState_no_visualization_selected_description":"Megjelenítés kiválasztása a mezőbeállítások kezeléséhez.","slotEditor_emptyState_widget_not_support_slot_selected_title":"A kiválasztott felületi elem nem használ mezőket","slotEditor_emptyState_widget_not_support_slot_selected_description":"Megjelenítés kiválasztása a mezőbeállítások kezeléséhez.","slotEditor_emptyState_multiple_visualizations_selected_title":"Több felületi elem van kiválasztva","slotEditor_emptyState_multiple_visualizations_selected_description":"Megjelenítés kiválasztása a mezőbeállítások kezeléséhez.","slotEditor_emptyState_visualization_has_error_title":"A megjelenítés nem jeleníthető meg","slotEditor_slotItem_tooltip":"Forrás:","slotEditor_emptyState_vis_not_created_title":"Nincs létrehozva megjelenítés","slotEditor_emptyState_vis_not_created_description":"Megjelenítés létrehozása a mezőbeállítások kezeléséhez.","slotEditor":"Mezők","slotEditorCoachMarkTitle":"Mezők elérése","slotEditorCoachMarkContents":"Oszlopok hozzáadása a mezőkhöz a megjelenítések összeállításához és módosításához.","toolbarDeleteFilterActionText":"Szűrő eltávolítása","toolbarActionFilter":"Szűrő","filterAutobinActionText":"Tároló szűrése","coachMarkTitleSpiralTarget":"Hatókör szerkesztése","coachMarkContentSpiralTarget":"Itt érheti el és módosíthatja a célhoz kijelölt tényezőket.","overlayDropZonePlaceHolderText":"Húzza ide az adatokat"},"__it":{"localFilters":"Filtri locali","slotEditorMsg1":"Campo obbligatorio","slotEditorMsg2":"Trascinare e rilasciare i dati nei campi sopra per costruire e filtrare la visualizzazione.","missingColumn":"Mancante: %{columnLabel}","placeholderDropzone":"Fare clic o trascinare i dati qui","slotEditor_emptyState_no_visualization_selected_title":"Nessuna visualizzazione selezionata","slotEditor_emptyState_no_visualization_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Il widget selezionato non utilizza campi","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Selezionati più elementi","slotEditor_emptyState_multiple_visualizations_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_visualization_has_error_title":"La visualizzazione non può essere visualizzata","slotEditor_slotItem_tooltip":"Sorgente:","slotEditor_emptyState_vis_not_created_title":"Nessuna visualizzazione creata","slotEditor_emptyState_vis_not_created_description":"Creare una visualizzazione per gestire le impostazioni del campo.","slotEditor":"Campi","slotEditorCoachMarkTitle":"Campi di accesso","slotEditorCoachMarkContents":"Aggiungi colonne ai campi per creare e modificare le visualizzazioni.","toolbarDeleteFilterActionText":"Rimuovi filtro","toolbarActionFilter":"Filtro","filterAutobinActionText":"Filtra bin","coachMarkTitleSpiralTarget":"Modifica ambito","coachMarkContentSpiralTarget":"Da qui è possibile accedere e modificare la selezione del driver per la propria destinazione.","overlayDropZonePlaceHolderText":"Trascinare qui i dati"},"__ja":{"localFilters":"ローカル・フィルター","slotEditorMsg1":"必須フィールド","slotEditorMsg2":"上のフィールドにデータをドラッグ・アンド・ドロップし、視覚化を作成してフィルターに掛けます。","missingColumn":"欠落しています: %{columnLabel}","placeholderDropzone":"データをクリックするかここにドラッグしてください","slotEditor_emptyState_no_visualization_selected_title":"視覚化が選択されていません","slotEditor_emptyState_no_visualization_selected_description":"フィールド設定を管理する視覚化を選択してください。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選択したウィジェットではフィールドは使用されません","slotEditor_emptyState_widget_not_support_slot_selected_description":"フィールド設定を管理する視覚化を選択してください。","slotEditor_emptyState_multiple_visualizations_selected_title":"複数のウィジェットが選択されています","slotEditor_emptyState_multiple_visualizations_selected_description":"フィールド設定を管理する視覚化を選択してください。","slotEditor_emptyState_visualization_has_error_title":"視覚化を表示できません","slotEditor_slotItem_tooltip":"ソース:","slotEditor_emptyState_vis_not_created_title":"視覚化が作成されていません","slotEditor_emptyState_vis_not_created_description":"フィールド設定を管理する視覚化を作成してください。","slotEditor":"フィールド","slotEditorCoachMarkTitle":"アクセス・フィールド","slotEditorCoachMarkContents":"視覚化を作成および変更するための列をフィールドに追加します。","toolbarDeleteFilterActionText":"フィルターの削除","toolbarActionFilter":"フィルター","filterAutobinActionText":"ビンのフィルター","coachMarkTitleSpiralTarget":"範囲の編集","coachMarkContentSpiralTarget":"ここでターゲットのドライバー選択にアクセスして変更することができます。","overlayDropZonePlaceHolderText":"ここにデータをドラッグ"},"__kk":{"localFilters":"Жергілікті сүзгілер","slotEditorMsg1":"Қажетті өріс","slotEditorMsg2":"Көрнекілікті сүзгілеу және құру үшін өрістерге деректерді сүйреп апарып тастаңыз.","missingColumn":"Жоқ: %{columnLabel}","placeholderDropzone":"Деректерді мына жерге нұқыңыз немесе сүйреңіз","slotEditor_emptyState_no_visualization_selected_title":"Көрнекілендіру таңдалмаған","slotEditor_emptyState_no_visualization_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Таңдалған виджет өрістерды пайдаланбайды","slotEditor_emptyState_widget_not_support_slot_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_multiple_visualizations_selected_title":"Бірнеше виджеттер таңдалды","slotEditor_emptyState_multiple_visualizations_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_visualization_has_error_title":"Көрнекілендіруді көрсету мүмкін емес","slotEditor_slotItem_tooltip":"Бастапқы:","slotEditor_emptyState_vis_not_created_title":"Жасалған көрнекілендіру жоқ","slotEditor_emptyState_vis_not_created_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру жасаңыз.","slotEditor":"Өрістер","slotEditorCoachMarkTitle":"Кіру өрістері","slotEditorCoachMarkContents":"Көрнекілендіру бейнелерді құру және өзгерту үшін өрістерге баған қосыңыз.","toolbarDeleteFilterActionText":"Сүзгіш жою","toolbarActionFilter":"Сүзгі","filterAutobinActionText":"Bin -дерді сүзгілеу","coachMarkTitleSpiralTarget":"Ауқымды өңдеу","coachMarkContentSpiralTarget":"Мұнда мақсатыңызға арналған драйвер таңдауына кіруге және оны өзгертуге болады.","overlayDropZonePlaceHolderText":"Деректерді осы жерге апарыңыз"},"__ko":{"localFilters":"로컬 필터","slotEditorMsg1":"필수 필드","slotEditorMsg2":"가상화를 빌드하고 필터링하려면 위의 필드에 데이터를 끌어서 놓습니다.","missingColumn":"누락: %{columnLabel}","placeholderDropzone":"데이터 클릭 또는 여기로 끌기","slotEditor_emptyState_no_visualization_selected_title":"선택된 시각화 없음","slotEditor_emptyState_no_visualization_selected_description":"시각화를 선택하여 필드 설정을 관리하십시오.","slotEditor_emptyState_widget_not_support_slot_selected_title":"선택한 위젯은 필드를 사용하지 않음","slotEditor_emptyState_widget_not_support_slot_selected_description":"시각화를 선택하여 필드 설정을 관리하십시오.","slotEditor_emptyState_multiple_visualizations_selected_title":"여러 위젯이 선택됨","slotEditor_emptyState_multiple_visualizations_selected_description":"시각화를 선택하여 필드 설정을 관리하십시오.","slotEditor_emptyState_visualization_has_error_title":"시각화를 표시할 수 없음","slotEditor_slotItem_tooltip":"소스:","slotEditor_emptyState_vis_not_created_title":"작성된 시각화 없음","slotEditor_emptyState_vis_not_created_description":"시각화를 작성하여 필드 설정을 관리하십시오.","slotEditor":"필드","slotEditorCoachMarkTitle":"필드 액세스","slotEditorCoachMarkContents":"필드에 열을 추가하여 시각화를 빌드하고 수정합니다.","toolbarDeleteFilterActionText":"필터 제거","toolbarActionFilter":"필터","filterAutobinActionText":"구간 필터","coachMarkTitleSpiralTarget":"범위 편집","coachMarkContentSpiralTarget":"대상에 대한 드라이버 선택에 액세스하고 수정할 수 있는 위치입니다.","overlayDropZonePlaceHolderText":"여기로 데이터 끌기"},"__nb":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere feltinnstillingene.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Valgbare felt","slotEditorCoachMarkContents":"Legg til kolonner for feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__nl":{"localFilters":"Lokale filters","slotEditorMsg1":"Verplicht veld","slotEditorMsg2":"Sleep gegevens naar de bovenstaande velden om de visualisatie te bouwen en te filteren.","missingColumn":"Ontbrekend: %{columnLabel}","placeholderDropzone":"Klik hier of versleep gegevens hiernaartoe","slotEditor_emptyState_no_visualization_selected_title":"Geen visualisatie geselecteerd","slotEditor_emptyState_no_visualization_selected_description":"Selecteer een visualisatie om de veldinstellingen te beheren.","slotEditor_emptyState_widget_not_support_slot_selected_title":"De geselecteerde widget gebruikt geen velden","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecteer een visualisatie om de veldinstellingen te beheren.","slotEditor_emptyState_multiple_visualizations_selected_title":"Meerdere widgets geselecteerd","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecteer een visualisatie om de veldinstellingen te beheren.","slotEditor_emptyState_visualization_has_error_title":"De visualisatie kan niet worden weergegeven","slotEditor_slotItem_tooltip":"Bron:","slotEditor_emptyState_vis_not_created_title":"Geen visualisatie gemaakt","slotEditor_emptyState_vis_not_created_description":"Maak een visualisatie om de veldinstellingen te beheren.","slotEditor":"Velden","slotEditorCoachMarkTitle":"Toegangsvelden","slotEditorCoachMarkContents":"Voeg kolommen aan de velden toe om visualisaties te bouwen en te wijzigen. ","toolbarDeleteFilterActionText":"Filter verwijderen","toolbarActionFilter":"Filteren","filterAutobinActionText":"Bins filteren","coachMarkTitleSpiralTarget":"Bereik bewerken","coachMarkContentSpiralTarget":"Dit is de plek waar u toegang hebt tot de driverselectie voor uw doel en waar u wijzigingen kunt aanbrengen.","overlayDropZonePlaceHolderText":"Sleep gegevens hiernaartoe"},"__no":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere feltinnstillingene.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Valgbare felt","slotEditorCoachMarkContents":"Legg til kolonner for feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__pl":{"localFilters":"Filtry lokalne","slotEditorMsg1":"Wymagane pole","slotEditorMsg2":"Przeciągnij i upuść dane w powyższych polach, aby utworzyć i przefiltrować wizualizację.","missingColumn":"Brak: %{columnLabel}","placeholderDropzone":"Kliknij lub przeciągnij dane w to miejsce","slotEditor_emptyState_no_visualization_selected_title":"Nie wybrano wizualizacji","slotEditor_emptyState_no_visualization_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Wybrany widget nie używa pól","slotEditor_emptyState_widget_not_support_slot_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_multiple_visualizations_selected_title":"Wybrano więcej niż jeden widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_visualization_has_error_title":"Nie można wyświetlić wizualizacji","slotEditor_slotItem_tooltip":"Źródło:","slotEditor_emptyState_vis_not_created_title":"Nie utworzono żadnej wizualizacji","slotEditor_emptyState_vis_not_created_description":"Utwórz wizualizację, aby zarządzać ustawieniami pól.","slotEditor":"Pola","slotEditorCoachMarkTitle":"Uzyskaj dostęp do pól","slotEditorCoachMarkContents":"Dodaj kolumny do pól, aby budować i modyfikować wizualizacje.","toolbarDeleteFilterActionText":"Usuń filtr","toolbarActionFilter":"Filtruj","filterAutobinActionText":"Filtruj kategorie","coachMarkTitleSpiralTarget":"Edytuj zakres","coachMarkContentSpiralTarget":"W tym miejscu można uzyskać dostęp do czynników dla zmiennej przewidywanej i zmodyfikować ich wybór.","overlayDropZonePlaceHolderText":"Przeciągnij dane w to miejsce"},"__pt":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo obrigatório","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__pt-br":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo obrigatório","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__ro":{"localFilters":"Filtre locale","slotEditorMsg1":"Câmp necesar","slotEditorMsg2":"Trageţi şi plasaţi datele în câmpurile de deasupra, pentru a construi şi filtra vizualizarea.","missingColumn":"Lipsă: %{columnLabel}","placeholderDropzone":"Faceţi clic sau trageţi date aici","slotEditor_emptyState_no_visualization_selected_title":"Nicio vizualizare selectată","slotEditor_emptyState_no_visualization_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Widget-ul selectat nu utilizează câmpuri.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_multiple_visualizations_selected_title":"Sunt selectate mai multe widget-uri","slotEditor_emptyState_multiple_visualizations_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_visualization_has_error_title":"Vizualizarea nu poate fi afişată","slotEditor_slotItem_tooltip":"Sursă:","slotEditor_emptyState_vis_not_created_title":"Nu a fost creată nicio vizualizare","slotEditor_emptyState_vis_not_created_description":"Creaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor":"Câmpuri","slotEditorCoachMarkTitle":"Accesare câmpuri","slotEditorCoachMarkContents":"Adăugaţi coloane la câmpuri pentru a construi şi modifica vizualizările.","toolbarDeleteFilterActionText":"Înlăturare filtru","toolbarActionFilter":"Filtru","filterAutobinActionText":"Filtrare bin-uri","coachMarkTitleSpiralTarget":"Editare domeniu","coachMarkContentSpiralTarget":"Aici puteţi accesa şi modifica selecţia de driver-e pentru ţinta dumneavoastră.","overlayDropZonePlaceHolderText":"Trageţi date aici"},"__ru":{"localFilters":"Локальные фильтры","slotEditorMsg1":"Обязательное поле","slotEditorMsg2":"Перетащите данные на находящиеся выше поля, чтобы построить визуализацию и применить к ней фильтр.","missingColumn":"Отсутствует: %{columnLabel}","placeholderDropzone":"Щелкните здесь или перетащите сюда данные","slotEditor_emptyState_no_visualization_selected_title":"Визуализация не отобрана","slotEditor_emptyState_no_visualization_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Выбранный виджет не использует поля","slotEditor_emptyState_widget_not_support_slot_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_multiple_visualizations_selected_title":"Выбрано несколько виджетов","slotEditor_emptyState_multiple_visualizations_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_visualization_has_error_title":"Вывести визуализацию невозможно","slotEditor_slotItem_tooltip":"Источник:","slotEditor_emptyState_vis_not_created_title":"Визуализация не создана","slotEditor_emptyState_vis_not_created_description":"Создайте визуализацию для управления настройками полей.","slotEditor":"Поля","slotEditorCoachMarkTitle":"Доступ к полям","slotEditorCoachMarkContents":"Добавьте в поля столбцы для построения и изменения визуализаций.","toolbarDeleteFilterActionText":"Удалить фильтр","toolbarActionFilter":"Фильтр","filterAutobinActionText":"Применить фильтр к контейнерам","coachMarkTitleSpiralTarget":"Изменить область","coachMarkContentSpiralTarget":"Здесь можно получить доступ и изменить выбор драйвера для целевого объекта.","overlayDropZonePlaceHolderText":"Перетащите сюда данные"},"__sl":{"localFilters":"Lokalni filtri","slotEditorMsg1":"Obvezno polje","slotEditorMsg2":"Povlecite in spustite podatke v polja zgoraj, da zgradite in filtrirate vizualizacijo.","missingColumn":"Manjka: %{columnLabel}","placeholderDropzone":"Kliknite ali povlecite podatke sem","slotEditor_emptyState_no_visualization_selected_title":"Izbrana ni nobena vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izbrani gradnik ne uporablja polj","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izbranih je več gradnikov","slotEditor_emptyState_multiple_visualizations_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacije ni mogoče prikazati","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Ustvarjena ni bila nobena vizualizacija","slotEditor_emptyState_vis_not_created_description":"Ustvarite vizualizacijo za upravljanje nastavitev polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Dostop do polj","slotEditorCoachMarkContents":"V polja dodajte stolpce, da izdelate in spremenite vizualizacije.","toolbarDeleteFilterActionText":"Odstrani filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Predali filtra","coachMarkTitleSpiralTarget":"Urejanje območja","coachMarkContentSpiralTarget":"Tukaj lahko dostopate do izbora gonilnikov za svoj cilj in jih spreminjate.","overlayDropZonePlaceHolderText":"Podatke povlecite sem"},"__sv":{"localFilters":"Lokala filter","slotEditorMsg1":"Obligatoriskt fält","slotEditorMsg2":"Dra data till fälten ovan för att skapa och filtrera visualiseringen.","missingColumn":"Saknas: %{columnLabel}","placeholderDropzone":"Klicka eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering vald","slotEditor_emptyState_no_visualization_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Vald widget använder inte fält","slotEditor_emptyState_widget_not_support_slot_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flera widgetar har valts","slotEditor_emptyState_multiple_visualizations_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_visualization_has_error_title":"Det går inte visa visualiseringen.","slotEditor_slotItem_tooltip":"Källa:","slotEditor_emptyState_vis_not_created_title":"Inga visualiseringar har skapats","slotEditor_emptyState_vis_not_created_description":"Skapa en visualisering för att hantera fältinställningarna.","slotEditor":"Fält","slotEditorCoachMarkTitle":"Åtkomstfält","slotEditorCoachMarkContents":"Lägg till kolumner i fälten för att bygga och ändra visualiseringar.","toolbarDeleteFilterActionText":"Ta bort filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filtrera bin","coachMarkTitleSpiralTarget":"Ändra omfattning","coachMarkContentSpiralTarget":"Här kan du komma åt och ändra valet av styrfunktioner för målet.","overlayDropZonePlaceHolderText":"Dra data hit"},"__th":{"localFilters":"ตัวกรองโลคัล","slotEditorMsg1":"ฟิลด์ที่ต้องการ","slotEditorMsg2":"ลากและปล่อยข้อมูลลงในฟิลด์ด้านบนเพื่อสร้างและกรองวิชวลไลเซชัน","missingColumn":"ไม่มี: %{columnLabel}","placeholderDropzone":"คลิกหรือลากข้อมูลที่นี่","slotEditor_emptyState_no_visualization_selected_title":"ไม่ได้เลือกวิชวลไลเซชัน","slotEditor_emptyState_no_visualization_selected_description":"เลือกวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_title":"วิดเจ็ตที่เลือกไม่ใช้ฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_description":"เลือกวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_multiple_visualizations_selected_title":"เลือกหลายวิดเจ็ต","slotEditor_emptyState_multiple_visualizations_selected_description":"เลือกวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_visualization_has_error_title":"ไม่สามารถแสดงวิชวลไลเซชัน","slotEditor_slotItem_tooltip":"ซอร์ส:","slotEditor_emptyState_vis_not_created_title":"ไม่มีการสร้างวิชวลไลเซชัน","slotEditor_emptyState_vis_not_created_description":"สร้างวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor":"ฟิลด์","slotEditorCoachMarkTitle":"เข้าถึงฟิลด์","slotEditorCoachMarkContents":"เพิ่มคอลัมน์ลงในฟิลด์เพื่อสร้างและปรับเปลี่ยนวิชวลไลเซชัน","toolbarDeleteFilterActionText":"ลบตัวกรอง","toolbarActionFilter":"ตัวกรอง","filterAutobinActionText":"ถังกรอง","coachMarkTitleSpiralTarget":"แก้ไขขอบเขต","coachMarkContentSpiralTarget":"นี่เป็นตำแหน่งที่คุณสามารถเข้าถึงและปรับเปลี่ยนการเลือกไดรเวอร์สำหรับเป้าหมายของคุณ","overlayDropZonePlaceHolderText":"ลากข้อมูลที่นี่"},"__tr":{"localFilters":"Yerel süzgeçler","slotEditorMsg1":"Zorunlu alan","slotEditorMsg2":"Görselleştirmeyi oluşturmak ve süzgeçten geçirmek için, verileri yukarıdaki alanlara sürükleyip bırakın.","missingColumn":"Eksik: %{columnLabel}","placeholderDropzone":"Tıklatın veya verileri buraya sürükleyin","slotEditor_emptyState_no_visualization_selected_title":"Bir görselleştirme seçilmedi","slotEditor_emptyState_no_visualization_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin","slotEditor_emptyState_widget_not_support_slot_selected_title":"Seçilen pencere öğesi alanları kullanmıyor","slotEditor_emptyState_widget_not_support_slot_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin","slotEditor_emptyState_multiple_visualizations_selected_title":"Birden çok pencere öğesi seçildi","slotEditor_emptyState_multiple_visualizations_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin","slotEditor_emptyState_visualization_has_error_title":"Görselleştirme görüntülenemiyor","slotEditor_slotItem_tooltip":"Kaynak:","slotEditor_emptyState_vis_not_created_title":"Bir görselleştirme oluşturulmadı","slotEditor_emptyState_vis_not_created_description":"Alan ayarlarını yönetmek için bir görselleştirme yaratın.","slotEditor":"Alanlar","slotEditorCoachMarkTitle":"Erişim alanları","slotEditorCoachMarkContents":"Görselleştirme oluşturmak ve görselleştirmeleri değiştirmek için alanlara sütun ekleyin.","toolbarDeleteFilterActionText":"Süzgeci kaldır","toolbarActionFilter":"Süzgeç","filterAutobinActionText":"Süzgeç bölmeleri","coachMarkTitleSpiralTarget":"Kapsamı düzenle","coachMarkContentSpiralTarget":"Burası, hedefiniz için sürücü seçimine erişebileceğiniz ve sürücü seçimini değiştirebileceğiniz yerdir.","overlayDropZonePlaceHolderText":"Verileri buraya sürükleyin"},"__zh":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方以构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-cn":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方以构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-tw":{"localFilters":"本端過濾器","slotEditorMsg1":"必要欄位","slotEditorMsg2":"將資料拖放至上方的欄位來建置及過濾視覺化。","missingColumn":"遺漏：%{columnLabel}","placeholderDropzone":"在這裡按一下或拖曳資料","slotEditor_emptyState_no_visualization_selected_title":"未選取任何視覺化","slotEditor_emptyState_no_visualization_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選取的小組件未使用欄位","slotEditor_emptyState_widget_not_support_slot_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_multiple_visualizations_selected_title":"已選取多個小組件","slotEditor_emptyState_multiple_visualizations_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_visualization_has_error_title":"無法顯示視覺化","slotEditor_slotItem_tooltip":"來源：","slotEditor_emptyState_vis_not_created_title":"未建立任何視覺化","slotEditor_emptyState_vis_not_created_description":"建立視覺化以管理欄位設定。","slotEditor":"欄位","slotEditorCoachMarkTitle":"存取欄位","slotEditorCoachMarkContents":"將直欄新增至欄位以建置並修改視覺化。","toolbarDeleteFilterActionText":"移除過濾器","toolbarActionFilter":"過濾","filterAutobinActionText":"過濾組","coachMarkTitleSpiralTarget":"編輯範圍","coachMarkContentSpiralTarget":"您可以在此處存取及修改目標動因選項。","overlayDropZonePlaceHolderText":"將資料拖曳到這裡"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Toolbar = __webpack_require__(73);

var ToolbarHelper = function () {
	/**
  * The ToolbarHelper is is designed to hide common jquery authoring toolbar code
  * for things like the filter dialog or the slot action menu.
  */
	function ToolbarHelper() {
		_classCallCheck(this, ToolbarHelper);
	}

	_createClass(ToolbarHelper, [{
		key: 'getToolbar',
		value: function getToolbar() {
			return this._actionMenuToolbar;
		}

		/**
   * build an action toolbar based on dashboard authoring toolbar class.
   * @param aActions - the actions to be added to the toolbarRoot
   * @param parentNode - the parentNode that contains the toolbar.
   * @param label - a label for the toolbar
   * @param userOptions - options such as placement and the attachPoint (class of the node where the toolbar will live)
   */

	}, {
		key: 'buildActionToolbar',
		value: function buildActionToolbar(aActions, parentNode, sLabel, userOptions) {
			var toolbarOptions = _underscore2.default.clone(userOptions);
			toolbarOptions.textOnly = true;
			toolbarOptions.flyoutClass = 'popover actionToolbarPopover text';

			this.$parentNode = (0, _jquery2.default)(parentNode);
			this.$parentNode.addClass('action-menu-opened');

			//We expect to find a div with this class under the parent to root the menu at (by default, the className is menuroot )
			var $attachPoint = this.$parentNode.find(userOptions.attachPoint || '.toolbarRoot');

			var toolbar = new Toolbar(toolbarOptions);
			toolbar.setName(sLabel);
			toolbar.addItems(aActions);
			toolbar.setSelectionContext([$attachPoint]);
			toolbar.show(toolbarOptions.placement);

			// This event is triggered only when user clicks away or press Escape to hide the toolbar.
			// We refresh the UI after that.
			// Other events like onPopupClose and bspopover.hidden are called when toolbar is changed.
			toolbar.on('flyout:hide', this.removeToolbar, this);
			toolbar.on('toolbar:remove', this.onToolbarRemove.bind(this));

			this._actionMenuToolbar = toolbar;
		}
	}, {
		key: 'removeToolbar',
		value: function removeToolbar() {
			if (this._actionMenuToolbar) {
				//Passing true to request the 'toolbar:remove' to trigger
				this._actionMenuToolbar.remove(true /* triggerEvent */);
			}
		}

		//Default implementation when the toolbar is removed.
		//A user can override this to perform some specific action at remove time in the arguments.

	}, {
		key: 'onToolbarRemove',
		value: function onToolbarRemove() {
			if (this.$parentNode) {
				this.$parentNode.removeClass('action-menu-opened');
				this.$parentNode = null;
			}
			if (this._actionMenuToolbar) {
				this._actionMenuToolbar = null;
			}
		}
	}]);

	return ToolbarHelper;
}();

exports.default = ToolbarHelper;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ACTION_ID = 'editFilterAction';

var EditFilterAction = function () {

	/**
  * Constructor
  *
  * @param {Object} dashboard - Dashboard API instance
  * @param {Object} content - Content API instance
  * @param {Object} metadataColumn - Metadata column instance
  * @param {string} filterId - filter id
  */
	function EditFilterAction(dashboard, content, metadataColumn, filterId) {
		_classCallCheck(this, EditFilterAction);

		this.dashboard = dashboard;
		this.content = content;
		this.metadataColumn = metadataColumn;
		this.filterId = filterId;

		this.visualization = content.getFeature('Visualization');

		this.itemContext = {
			itemId: metadataColumn.getId(),
			itemName: metadataColumn.getLabel(),
			dataType: metadataColumn.getDataType(),
			isHierarchy: metadataColumn.isHierarchy(),
			isNamedSet: metadataColumn.isNamedSet(),
			sourceId: this.visualization.getDataSource().getId()
		};

		this.renderModule = this.getEditorModuleName();
		this.toolbarContribution = [{
			name: 'filter',
			text: _StringResources2.default.get('toolbarActionFilter'),
			label: _StringResources2.default.get('toolbarActionFilter'),
			icon: 'common-filter',
			type: 'NextView',
			group: ACTION_ID,
			showHeading: false,
			viewModule: this.renderModule,
			viewOptions: this.getViewOptions.bind(this)
		}];
	}

	_createClass(EditFilterAction, [{
		key: 'getActionId',
		value: function getActionId() {
			return ACTION_ID;
		}

		/**
   * get the set of availableSort actions setting the selected state to match
   * the state of the data.
   * @returns the sort actions and their state.
   */

	}, {
		key: 'getAvailableActions',
		value: function getAvailableActions() {
			return this.toolbarContribution;
		}
	}, {
		key: 'getViewOptions',
		value: function getViewOptions() {
			return {
				height: 300,
				width: 212, // those are hints only; for the placement of the toolbar.
				metadataColumn: this.metadataColumn,
				logger: this.dashboard.getService(this.dashboard.GLOBAL_SERVICES.LOGGER),
				dashboardApi: this.dashboard,
				content: this.content,
				visualization: this.visualization,
				itemContext: this.itemContext,
				showBoxShadow: true // it surrounds the entire flyout not the subview
			};
		}

		/**
   * @returns a path to the editor dialog to be loaded.
   */

	}, {
		key: 'getEditorModuleName',
		value: function getEditorModuleName() {
			return 'dashboard-analytics/dialogs/CommonViewWrapper';
		}

		/**
   * Check whether the edit action is enabled or not
   * @returns boolean - TRUE if the action is editable and FALSE if the action is not editable
   */

	}, {
		key: 'isEnabled',
		value: function isEnabled() {
			var _this = this;

			if (!this.filterId) {
				return false;
			}
			var targetFilter = this.visualization.getLocalFilters().getFilterList().find(function (filter) {
				return filter.id === _this.filterId;
			});
			if (!targetFilter) {
				return false;
			}
			return !targetFilter.readOnly;
		}
	}]);

	return EditFilterAction;
}();

exports.default = EditFilterAction;

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _SlotEditorStateAPI = __webpack_require__(69);

var _SlotEditorStateAPI2 = _interopRequireDefault(_SlotEditorStateAPI);

var _SlotEditorModel = __webpack_require__(70);

var _SlotEditorModel2 = _interopRequireDefault(_SlotEditorModel);

var _mobxStateTree = __webpack_require__(3);

var _refined_ = __webpack_require__(81);

var _refined_2 = _interopRequireDefault(_refined_);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APIFactory = __webpack_require__(15);
var ContentActionsProviderAPI = __webpack_require__(82);

var PROVIDER_ID = 'SlotEditor';
var ADD_CONTENT_EVENT_NAME = 'add:content';

var SlotEditorState = function () {
	function SlotEditorState(_ref) {
		var features = _ref.features;

		_classCallCheck(this, SlotEditorState);

		this._features = features;
		this._dashboardApi = features.API;
		this._dashboardSettings = features.DashboardSettings;
		this._slideout = features.InAppSlideoutState;
		this._api = null;
		this._model = null;

		this._initialize();
	}

	_createClass(SlotEditorState, [{
		key: 'getAPI',
		value: function getAPI() {
			return this._api;
		}
	}, {
		key: '_initialize',
		value: function _initialize() {
			var _this = this;

			this._api = APIFactory.createAPI(this, [_SlotEditorStateAPI2.default]);
			this._model = _SlotEditorModel2.default.create({
				slotsModel: {},
				localFiltersModel: {}
			}, {
				dashboardApi: this._dashboardApi
			});

			// WARNING: the DashboardState feature is a runtime dependency for this feature.
			// please use carefully and make sure it is not accessed / loaded on initialization / construction of this feature.
			this._slideout.registerContribution(this.getProviderId(), {
				name: 'slotEditor',
				group: 'slotEditorAction',
				coachMark: this._getCoachMarkOptions(),
				section: ContentActionsProviderAPI.ACTION_SECTION.PANEL,
				order: 30,
				label: _StringResources2.default.get('slotEditor'),
				text: _StringResources2.default.get('slotEditor'),
				className: 'buttonWithText',
				icon: _refined_2.default.id,
				type: 'Button',
				disabled: function disabled() {
					if (!_this._api) {
						// instance destroyed
						return;
					}
					return _this._features['DashboardState'].getUiState().eventGroups;
				},
				isEnabled: function isEnabled() {
					if (!_this._api) {
						// instance destroyed
						return;
					}
					// the dashboard app (ie. PA) can decide to forcefully enable the slot editor, regardless of the dashboard mode.
					var isForced = _this._settings.forceEnabled;
					var isAuthoringMode = _this._features['DashboardState'].getUiState().authoring;
					return isForced || isAuthoringMode && _this.hasCapability(_this._dashboardApi, 'canAuthorDashboard');
				}
			});
			this._dashboardApi.getCanvasWhenReady().then(function (canvas) {
				_this.canvas = canvas;
				_this.canvas.on(ADD_CONTENT_EVENT_NAME, _this._openSlotsSlideOut, _this);
			});
			if (this._dashboardSettings) {
				this._settings = this._dashboardSettings.get('slotEditor') || {};
			}
		}

		// TODO: use from a common place. (method copied from dashboard-core)

	}, {
		key: 'hasCapability',
		value: function hasCapability(api) {
			var capability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'canUseInteractiveDashboard';

			var getCoreSvc = api.getCoreSvc || api.getGlassCoreSvc;

			var _getCoreSvc$call = getCoreSvc.call(api, '.UserProfile'),
			    _getCoreSvc$call$capa = _getCoreSvc$call.capabilities,
			    capabilities = _getCoreSvc$call$capa === undefined ? [] : _getCoreSvc$call$capa;

			return capabilities.indexOf(capability) !== -1;
		}
	}, {
		key: 'getModel',
		value: function getModel() {
			return this._model;
		}
	}, {
		key: 'getProviderId',
		value: function getProviderId() {
			return PROVIDER_ID;
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this._slideout.removeContribution(this.getProviderId());

			if (this.canvas) {
				this.canvas.off(ADD_CONTENT_EVENT_NAME, this._openSlotsSlideOut, this);
				this.canvas = null;
			}
			this._dashboardApi = null;
			this._api = null;
			(0, _mobxStateTree.destroy)(this._model);
			this._model = null;
			this._slideout = null;
		}
	}, {
		key: '_getCoachMarkOptions',
		value: function _getCoachMarkOptions() {
			return {
				title: _StringResources2.default.get('slotEditorCoachMarkTitle'),
				contents: _StringResources2.default.get('slotEditorCoachMarkContents'),
				id: 'com.ibm.bi.dashboard.slotEditorAction',
				dashboard: this._dashboardApi
			};
		}
	}, {
		key: '_openSlotsSlideOut',
		value: function _openSlotsSlideOut() {
			var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var newContentIds = payload.info && payload.info.events && payload.info.events.map(function (event) {
				return event.info && event.info.newContentId;
			}) || [];
			for (var i = 0; i < newContentIds.length; i++) {
				var newContentId = newContentIds[i];
				var content = newContentId && this.canvas.getContent(newContentId);
				var visualization = content && content.getFeature('Visualization');
				var definition = visualization && visualization.getDefinition();
				var slotDefinitions = definition && definition.getSlotList();
				// open the slot editor if the visualization has slots defined
				if (slotDefinitions && slotDefinitions.length) {
					var dataItems = visualization.getSlots().getDataItemList() || [];
					if (!dataItems.length) {
						this._features['DashboardState'].setSidePanelCurrentView(this.getProviderId());
						if (!this._slideout.isOpen()) {
							this._slideout.open();
						}
					}
				}
			}
		}
	}]);

	return SlotEditorState;
}();

module.exports = SlotEditorState;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var SlotEditorStateAPI = function () {
	function SlotEditorStateAPI() {
		_classCallCheck(this, SlotEditorStateAPI);
	}

	_createClass(SlotEditorStateAPI, [{
		key: "getModel",


		/**
   * @function SlotEditorStateAPI#getModel
   * @description get the intance of SlotEditorModel
   * @return {SlotEditorModel} the intance of SlotEditorModel
   */
		value: function getModel() {}

		/**
   * @function SlotEditorStateAPI#getProviderId
   * @description get slot editor provider id
   * @return {String} the provider id
   */

	}, {
		key: "getProviderId",
		value: function getProviderId() {}
	}]);

	return SlotEditorStateAPI;
}();

exports.default = SlotEditorStateAPI;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(3);

var _SlotsModel = __webpack_require__(71);

var _SlotsModel2 = _interopRequireDefault(_SlotsModel);

var _LocalFiltersModel = __webpack_require__(76);

var _LocalFiltersModel2 = _interopRequireDefault(_LocalFiltersModel);

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: vis-slot-editor
 *| (C) Copyright IBM Corp. 2019, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var SLOT_EDITOR_STATES = {
	DISPLAY: 'DISPLAY',
	EMPTY: {
		NO_VIS_CREATED: 'NO_VIS_CREATED',
		NOT_SUPPORT_SLOTS: 'NOT_SUPPORT_SLOTS',
		NO_VIS_SELECTED: 'NO_VIS_SELECTED',
		MUILTI_SELECTION: 'MUILTI_SELECTION',
		ERROR: 'ERROR'
	}
};

exports.default = _mobxStateTree.types.model('SlotEditorModel', {
	slotsModel: _SlotsModel2.default,
	localFiltersModel: _LocalFiltersModel2.default
}).volatile(function () {
	return {
		dashboardApi: null,
		canvas: null,
		selectedContents: [],
		slotEditorState: ''
	};
}).views(function (self) {
	return {
		/**
   * @return {array} slot apis
   */
		getSlotInfo: function getSlotInfo() {
			if (self.slotsModel && (0, _mobxStateTree.isAlive)(self.slotsModel)) {
				return self.slotsModel.getSlotInfo();
			} else {
				return [];
			}
		},

		/**
   * @return {array} local filters
   */
		getLocalFilters: function getLocalFilters() {
			if (self.localFiltersModel && (0, _mobxStateTree.isAlive)(self.localFiltersModel)) {
				return self.localFiltersModel.getLocalFilters();
			} else {
				return [];
			}
		},

		/**
   * @param {Object} slot - slot api
   * @return {Object} - SlotDataItemHandler
   */
		getSlotDataItemHandler: function getSlotDataItemHandler(slot, indexInSlot) {
			if (self.slotsModel) {
				return self.slotsModel.getSlotDataItemHandler(slot, indexInSlot);
			} else {
				return null;
			}
		},

		/**
   * @return {Object} - FilterActionHandler 
   */
		getFilterActionHandler: function getFilterActionHandler() {
			if (self.localFiltersModel) {
				return self.localFiltersModel.getFilterActionHandler();
			} else {
				return null;
			}
		},


		get SLOT_EDITOR_STATES() {
			return SLOT_EDITOR_STATES;
		}
	};
}).actions(function (self) {
	var listeners = [];
	var _getLocalFiltersInfo = function _getLocalFiltersInfo(visualization) {
		var localFilters = visualization.getLocalFilters();
		var localFiltersInfo = localFilters.getFilterList();
		if (localFiltersInfo && localFiltersInfo.length) {
			// These are what we will display in the `local filters` in the slot editor
			var mappedItemIds = {};
			visualization.getSlots().getMappedSlotList().forEach(function (mappedSlot) {
				mappedSlot.getDataItemList().forEach(function (dataItem) {
					mappedItemIds[dataItem.getColumnId()] = true;
				});
			});

			var localFiltersDesc = localFilters.getFiltersDesc();
			return localFiltersInfo.filter(function (localFilterInfo) {
				var shouldShowInLocalFilter = false;
				if (localFilterInfo.columnId) {
					shouldShowInLocalFilter = !(mappedItemIds[localFilterInfo.columnId] && !localFilterInfo.readOnly);
				}
				return shouldShowInLocalFilter;
			}).map(function (localFilterInfo) {
				var foundLocalFilterDesc = !localFilterInfo.isMissing && localFiltersDesc && localFiltersDesc.find(function (localFilterDesc) {
					return localFilterDesc.dataId === localFilterInfo.id;
				});
				var dataSource = visualization.getDataSource();
				// Make sure the metadata is loaded before accessing it to get column info
				var metadataIsLoaded = dataSource && dataSource.getState() === dataSource.STATE.READY;
				return {
					id: localFilterInfo.id,
					columnId: localFilterInfo.columnId,
					metadataColumn: localFilterInfo.isMissing || !metadataIsLoaded ? null : dataSource.getMetadataColumn(localFilterInfo.columnId),
					name: localFilterInfo.isMissing ? null : foundLocalFilterDesc && foundLocalFilterDesc.title,
					filterString: foundLocalFilterDesc && foundLocalFilterDesc.description,
					numberOfFilterItems: (0, _utils.getNumberOfFilterItems)(localFilterInfo),
					isMissing: localFilterInfo.isMissing
				};
			});
		}
		return null;
	};

	/**
  * @param {*} layerId
  * @returns true/false to hide/show layers
  */
	var _isHideLayer = function _isHideLayer(visualization, layerId) {
		var visDefinition = visualization.getDefinition();
		var datasets = visDefinition.getDatasetList() || [];
		var layer = datasets.find(function (dataset) {
			return dataset.id === layerId;
		}) || {};
		return !layer.caption;
	};

	/**
 * returns an array of objects that describe slots, the views and layers they're associated with,
 * TODO: In future, this function can be extended to include items that are 'context' (dataItems in a view not mapped to a slot)
 * @param options Supports the 'includeUnmappedSlots: true' option which would return slotAPIs and layers for unmapped as well as mapped slots.
 * @returns an array of Slot/View information objects by view (or layer depending on how you think of it!)
 */
	var _getSlotInfoForEachView = function _getSlotInfoForEachView(visualization) {
		var slots = visualization.getSlots().getSlotList();
		var slotDefinitions = visualization.getDefinition().getSlotList();
		var sharedSlots = slotDefinitions.filter(function (slotDefn) {
			return slotDefn.getDatasetIdList().length > 1;
		});
		var slotAndViewInfoArray = [];
		if (sharedSlots.length > 0) {
			// single UI layer
			var defnLayerId = 'data';
			slotAndViewInfoArray.push({
				slotAPIs: slots || [],
				layerId: defnLayerId,
				layerCaption: null,
				isHideLayer: _isHideLayer(visualization, defnLayerId)
			});
		} else {
			var slotsGroupedByLayer = _underscore2.default.groupBy(slots, function (slot) {
				return slot.getDefinition().getDatasetIdList()[0];
			});
			//Ensure an array of slots arrays is returned in definition order.
			visualization.getDefinition().getDatasetList().forEach(function (dataset, index) {
				var slotsByDataset = slotsGroupedByLayer[dataset.id];
				slotAndViewInfoArray.push({
					slotAPIs: slotsByDataset || [],
					layerId: dataset.id,
					layerCaption: dataset.caption || dataset.id,
					isHideLayer: _isHideLayer(visualization, dataset.id),
					open: index === 0
				});
			});
		}
		return slotAndViewInfoArray;
	};

	var _onSelectionChange = null;
	var _onModelChange = null;

	return {
		afterCreate: function afterCreate() {
			var createModelChangeFn = function createModelChangeFn(setupEvents) {
				return function () {
					if ((0, _mobxStateTree.isAlive)(self)) {
						self._updateModel(setupEvents);
					}
				};
			};

			// @todo: STOP using debounce
			// SHOULD use transaction feature instead
			// Event handling of selection and event handling for mapping change needs to be seprated.
			// Combining the two, results in unnecessary on/off upon mapping.
			// Added [setupEvents] to distinguish the two cases for now.

			//Need two debounce handlers as they deal with different events and interferes with each other.
			// The different usage of _updateModelOnChange handler
			// 1. handler for content selection change.
			_onSelectionChange = _underscore2.default.debounce(createModelChangeFn(true));
			// 2. hander for slots mapping change.
			_onModelChange = _underscore2.default.debounce(createModelChangeFn(false));

			self.dashboardApi = (0, _mobxStateTree.getEnv)(self).dashboardApi;
			if (self.dashboardApi) {
				if (self.slotsModel) {
					self.slotsModel.setDashboardApi(self.dashboardApi);
				}
				if (self.localFiltersModel) {
					self.localFiltersModel.setDashboardApi(self.dashboardApi);
				}
				self.dashboardApi.getCanvasWhenReady().then(function (canvas) {
					self.setCanvas(canvas);
					canvas.on('change:selections:select', _onSelectionChange);
					canvas.on('change:selections:deselect', _onSelectionChange);

					// listening on shaping changes
					listeners.push(self.dashboardApi.on('shapingmodel:changed', function (payload) {
						var needsRefresh = payload && !payload.noRefresh;
						if (needsRefresh) {
							_onModelChange();
						}
					}));

					// update the model to initial state
					_onModelChange();
				});
			}
		},
		beforeDestroy: function beforeDestroy() {
			listeners.forEach(function (listener) {
				return listener.remove();
			});
			if (self.canvas) {
				self.canvas.off('change:selections:select', _onSelectionChange);
				self.canvas.off('change:selections:deselect', _onSelectionChange);
			}
		},
		setCanvas: function setCanvas(canvas) {
			self.canvas = canvas;
		},
		_updateModel: function _updateModel(setupEvents) {
			self._setSlotEditorState();
			self._setSlotsAndLocalFilters(setupEvents);
		},
		_setSlotEditorState: function _setSlotEditorState() {
			var selectedContents = self.canvas.getSelectedContentList();
			self.selectedContents = selectedContents;
			if (selectedContents.length === 0) {
				// no widget selected
				self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.NO_VIS_SELECTED;
			} else if (selectedContents.length === 1) {
				// one widget selected
				var content = selectedContents[0];
				var contentType = content && content.getType();
				if (contentType === 'widget.live') {
					// live widget selected
					var visualization = content.getFeature('Visualization');
					if (visualization) {
						var visDefinition = visualization.getDefinition();
						// sets error state iff there exists vis definition error.
						if (visDefinition.getState().getError()) {
							self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.ERROR;
						} else {
							var slots = visDefinition.getSlotList();
							if (slots && slots.length) {
								self.slotEditorState = SLOT_EDITOR_STATES.DISPLAY;
							} else {
								self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.NOT_SUPPORT_SLOTS;
							}
						}
					} else {
						self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.ERROR;
					}
				} else if (contentType === 'widget.placeholder' || contentType === 'widget.multipurpose') {
					self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED;
				} else if (contentType === 'group') {
					self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.MUILTI_SELECTION;
				} else {
					// widget not support slots
					self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.NOT_SUPPORT_SLOTS;
				}
			} else {
				// multiple widgets selected
				self.slotEditorState = SLOT_EDITOR_STATES.EMPTY.MUILTI_SELECTION;
			}
		},
		_setSlotsAndLocalFilters: function _setSlotsAndLocalFilters(setupEvents) {
			var content = null;
			var slotInfo = [];
			var localFilters = [];
			content = self.selectedContents && self.selectedContents[0];
			if (self.slotEditorState === SLOT_EDITOR_STATES.DISPLAY) {
				var visualization = content.getFeature('Visualization');
				if (visualization) {
					// If the visualization depends on a datasource, make sure the data source is ready to use before getting slots info  
					var dataSource = visualization.getDataSource();
					if (!dataSource || dataSource.getState() === dataSource.STATE.READY) {
						slotInfo = _getSlotInfoForEachView(visualization) || [];
						localFilters = _getLocalFiltersInfo(visualization) || [];
					}
				}
			}
			if (self.slotsModel && (0, _mobxStateTree.isAlive)(self.slotsModel)) {
				if (setupEvents) {
					self.slotsModel.clear();
					self.slotsModel.setContent(content);
					self.slotsModel.setVisualization();
					self.slotsModel.setUpEvents(_onModelChange);
				}
				self.slotsModel.setSlotInfo(slotInfo);
			}
			if (self.localFiltersModel && (0, _mobxStateTree.isAlive)(self.localFiltersModel)) {
				if (setupEvents) {
					self.localFiltersModel.clear();
					self.localFiltersModel.setContent(content);
					self.localFiltersModel.setUpEvents(_onModelChange);
				}
				self.localFiltersModel.setLocalFilters(localFilters);
			}
		}
	};
});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(3);

var _VisSlotDataItemHandler = __webpack_require__(72);

var _VisSlotDataItemHandler2 = _interopRequireDefault(_VisSlotDataItemHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var MemUtil = __webpack_require__(75);

exports.default = _mobxStateTree.types.model('SlotsModel', {
	slotInfo: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.frozen()), [])
}).volatile(function (self) {
	return {
		visSlotDataItemHandlersMap: {},
		content: null,
		visualization: null,
		dashboardAPI: null,
		/**
   * @param {Object} slot - slot api
   * @return {Object} - SlotDataItemHandler
   */
		getSlotDataItemHandler: function getSlotDataItemHandler(slot, indexInSlot) {
			if (!self.content) {
				return null;
			}
			if (!self.visualization) {
				self.setVisualization();
			}
			var handlerKey = [slot.getDefinition().getDatasetIdList()[0], slot.getDefinition().getId(), indexInSlot].join(':');

			//Re-use or allocate a slotDataItemHandler.
			var slotDataItemHandler = self.visSlotDataItemHandlersMap[handlerKey];
			if (!slotDataItemHandler || MemUtil.isDestroyed(slotDataItemHandler.slot)) {
				var fnAcceptsOlapV2 = void 0;
				if (self.visualization.getType() === 'Crosstab') {
					var utils = self.content.getFeature('VisDnD.utils');
					if (utils) {
						fnAcceptsOlapV2 = utils.acceptsOlapV2;
					}
				}
				var slotActions = self.content.getFeature('SlotActions');
				var cbGetActionsForSlot = slotActions.getSlotActionList.bind(slotActions);
				slotDataItemHandler = new _VisSlotDataItemHandler2.default(slot, indexInSlot, cbGetActionsForSlot, self.visualization, self.dashboardApi, self.content, fnAcceptsOlapV2);
				self.setVisSlotDataItemHandler(handlerKey, slotDataItemHandler);
			}
			return slotDataItemHandler;
		}
	};
}).views(function (self) {
	return {
		/**
   * @return {array} slot info
   */
		getSlotInfo: function getSlotInfo() {
			return self.slotInfo;
		}
	};
}).actions(function (self) {
	var eventCallback = null;
	return {
		beforeDestroy: function beforeDestroy() {
			self.clearEvents();
		},
		setContent: function setContent(content) {
			self.content = content;
		},
		setUpEvents: function setUpEvents(callback) {
			if (self.content) {
				eventCallback = callback;
				self.content.on('change', eventCallback);
				self.visDefinitions = self.dashboardApi.getFeature('VisDefinitions');
				self.visDefinitions.on('refresh:definition', eventCallback);
			}
		},
		setVisualization: function setVisualization() {
			if (self.content) {
				self.visualization = self.content.getFeature('Visualization');
			} else {
				self.visualization = null;
			}
		},
		setDashboardApi: function setDashboardApi(dashboardApi) {
			self.dashboardApi = dashboardApi;
		},
		setVisSlotDataItemHandler: function setVisSlotDataItemHandler(handlerKey, slotDataItemHandler) {
			self.visSlotDataItemHandlersMap[handlerKey] = slotDataItemHandler;
		},
		setSlotInfo: function setSlotInfo() {
			var slotInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			self.slotInfo = slotInfo;
		},
		clear: function clear() {
			self.clearEvents();
			self.content = null;
			self.visualization = null;
			self.slotInfo = [];
			self.visSlotDataItemHandlersMap = {};
		},
		clearEvents: function clearEvents() {
			if (self.content) {
				self.content.off('change', eventCallback);
				self.visDefinitions.off('refresh:definition', eventCallback);
				eventCallback = null;
			}
		}
	};
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exports.MULTI_MEASURES_SERIES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ToolbarHelper = __webpack_require__(16);

var _ToolbarHelper2 = _interopRequireDefault(_ToolbarHelper);

var _utils = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// -----TEMPORARY------- will remove after we have the feature apis of these things
var ActionTypes = __webpack_require__(74);
var MULTI_MEASURES_SERIES = exports.MULTI_MEASURES_SERIES = '_multiMeasuresSeries';
// ---------------------

/**
 * The VisSlotDataItemHandler is a helper class which handles assigning and moving DataItems in slots
 * Items can be inserted/replaced into slots from metadata (as provided by the metadata tree)
 * or come from other SlotDataItemHandler instances (when other slot items being moved or swapped).
 * The main purpose of this helper class is to support drag and drop in the slot editor.
 */
var VisSlotDataItemHandler = function () {
	/**
   * @param slotAPI - the slotAPI to bind this action handler to
   * @param indexInSlot - the index of the data item of interest in this slotType
   * @param cbGetActionsForSlot - a callback function that can provide the actions associated with this slot/dataItemModel
   * @param visualization - the new visualization API
   * @param dashboardApi - dashboardApi
   * @param content - contentAPI associated with the slots
   * @param fnAccepts - injected function to validate accepts, it is called if it is defined, currently used for V2 xtab
   */
	function VisSlotDataItemHandler(slotAPI, indexInSlot, cbGetActionsForSlot, visualization, dashboardApi, content, fnAccepts) {
		_classCallCheck(this, VisSlotDataItemHandler);

		this.content = content;
		this.dashboardApi = dashboardApi;
		this.transactionApi = dashboardApi.getFeature('Transaction');
		this.indexInSlot = indexInSlot;
		this._getActions = cbGetActionsForSlot;
		this.setSlotAPI(slotAPI);
		this._toolbarHelper = new _ToolbarHelper2.default();
		this.visualization = visualization;
		this.visDnD = this.content.getFeature('VisDnD');
		this.fnAccepts = fnAccepts;
	}

	_createClass(VisSlotDataItemHandler, [{
		key: 'setSlotAPI',
		value: function setSlotAPI(slot) {
			this.slot = slot;
			this.slotId = slot.getDefinition().getId();
		}
	}, {
		key: 'getSlotAPI',
		value: function getSlotAPI() {
			return this.slot;
		}
	}, {
		key: 'getContentId',
		value: function getContentId() {
			return this.content.getId();
		}
	}, {
		key: 'getGraphicData',
		value: function getGraphicData() {
			// if this content supports the property `value.graphic.content`,
			// then we return the value of it, otherwise return null
			if (this.content.getPropertyNameList().indexOf('value.graphic.content') !== -1) {
				return this.content.getPropertyValue('value.graphic.content');
			}
			return null;
		}
	}, {
		key: 'getDatasourceId',
		value: function getDatasourceId() {
			var dataSource = this.visualization.getDataSource();
			if (dataSource) {
				return dataSource.getId();
			}
			return null;
		}
	}, {
		key: 'getFilterStringAndNumber',
		value: function getFilterStringAndNumber() {
			var result = {};
			var dataItem = this.slot.getDataItemList()[this.indexInSlot];
			var columnId = dataItem && dataItem.getColumnId();
			if (columnId && columnId !== MULTI_MEASURES_SERIES) {
				// Find the local filter which can be displayed under the dataItem.
				var localFilters = this.visualization.getLocalFilters();
				var localFiltersInfo = localFilters && localFilters.getFilterList();
				if (localFiltersInfo && localFiltersInfo.length) {
					var columnFilter = localFiltersInfo.find(function (localFilterInfo) {
						if (localFilterInfo.readOnly) {
							return false;
						}
						if (localFilterInfo.aggregationType) {
							return localFilterInfo.columnId === columnId && dataItem.getAggregation() === localFilterInfo.aggregationType;
						} else {
							// If the case is when there is an ordinal and attribute we dont want to
							// display the filter beneath it.
							return localFilterInfo.columnId === columnId;
						}
					});
					if (columnFilter) {
						// get filterString
						var filtersDesc = localFilters.getFiltersDesc();
						var columnFilterDesc = filtersDesc.find(function (filterDesc) {
							return filterDesc.dataId === columnFilter.id;
						});
						if (columnFilterDesc) {
							result.filterString = columnFilterDesc.description;
						}
						// get number of filter items
						result.numberOfFilterItems = (0, _utils.getNumberOfFilterItems)(columnFilter);
					}
				}
			}
			return result;
		}
	}, {
		key: 'isMeasureGroupItem',
		value: function isMeasureGroupItem() {
			if (this._isMultiMeasuresSeriesSlot()) {
				var thisDataItem = this.slot.getDataItemList()[this.indexInSlot];
				return thisDataItem && thisDataItem.getColumnId() === '_multiMeasuresSeries';
			}
			return false;
		}

		// This function is copied from the static function SlotAPIUtil.isMultiMeasuresSeriesSlot in live-widget component

	}, {
		key: '_isMultiMeasuresSeriesSlot',
		value: function _isMultiMeasuresSeriesSlot() {
			var dataItemList = this.slot.getDataItemList();
			return dataItemList.find(function (dataItem) {
				return dataItem.getColumnId() === MULTI_MEASURES_SERIES;
			}) ? true : false;
		}
	}, {
		key: '_getTargetIndex',
		value: function _getTargetIndex(dropAfter) {
			return this.indexInSlot + (dropAfter ? 1 : 0);
		}
	}, {
		key: 'insertItemFromTypeInSlot',
		value: function insertItemFromTypeInSlot(metadataColumn, sourceId, options) {
			var replaceSlotItem = options.replaceSlotItem;

			var dataSource = this.dashboardApi.getFeature('DataSources').getDataSource(sourceId);
			if (dataSource) {
				var target = this.getDropTargetInfo( /*addAfter*/!replaceSlotItem);
				var source = {
					type: 'metadataColumns',
					data: [metadataColumn]
				};
				if (metadataColumn && metadataColumn.getType()) {
					//NOTE: onDrop will validate (call accepts)
					this.visDnD.onDrop(source, target);
				}
			}
		}

		/* check if this slot can have one more item in it*/

	}, {
		key: 'canAcceptMoreItems',
		value: function canAcceptMoreItems() {
			return this._acceptsCommon(1, true);
		}

		/**
   * @returns {number} of slot items in a slot
   */

	}, {
		key: 'getNumberItemsInSlot',
		value: function getNumberItemsInSlot() {
			return this.slot.getDataItemList().length;
		}
	}, {
		key: 'getDropTargetInfo',
		value: function getDropTargetInfo(addAfter) {
			var additionalInfoOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var dropTargetInfo = {
				type: 'slot.item',
				info: {
					contentId: this.getContentId(),
					slot: this.getSlotAPI(),
					indexInSlot: this.indexInSlot,
					addAfter: addAfter
				}
			};

			Object.keys(additionalInfoOptions).forEach(function (key) {
				dropTargetInfo.info[key] = additionalInfoOptions[key];
			});
			return dropTargetInfo;
		}
	}, {
		key: '_acceptsCommon',
		value: function _acceptsCommon(countOfItemsToDrop, addAfter) {
			//IF this definition contains (or could contain) a multiMeasuresSeries item,
			//You CAN drop on or after in a values slot (even though values has maxItems of 1 => multi-items go where 'Measure Group (n)' is)
			if (this.slotId === 'values' && this._isMultiMeasuresSeriesSlot() || this.slot.getDefinition().isMultiMeasureSupported()) {
				return true;
			}

			//You CAN'T drop more items than the slot can allow.
			return !this._exceedsItemsLimit(countOfItemsToDrop, addAfter);
		}
	}, {
		key: '_exceedsItemsLimit',
		value: function _exceedsItemsLimit(countOfItemsToDrop, addAfter) {
			var limit = this.slot.getDefinition().getMaxItems();
			if (typeof limit !== 'number' || limit < 0) {
				// no limit verification if maxItems is null or undefined or something else than a positive number (0 is considered as positive in this function)
				return false;
			}
			var mappedItems = this.slot.getDataItemList().length;
			//When dropping on top of an existing slot dataItem, we replace it with the items we're dropping.
			var mappedItemsAfterDrop = countOfItemsToDrop + mappedItems - (addAfter ? 0 : 1);
			return mappedItemsAfterDrop > limit;
		}

		/**
   * Performs swaps of the item represented by the sourceDataItemHandler with the item represented by this handler
   * either as a 'replace' or an 'addAfter' operation.
   * NOTE: This function is now only used for the Slot to Slot A11Y case.
   * @param sourceDataItemHandler - The handler representing the source DataItem being moved.
   * @param addAfter (optional) - a boolean indicating if this is a replace or append wrt this dataItem/index.
   */

	}, {
		key: 'swapSlotItems',
		value: function swapSlotItems(sourceDataItemHandler, addAfter) {
			return this.onDrop(
			//SourceInfo (as defined in DnDSlotItemHandler)
			{
				data: {
					source: {
						slot: sourceDataItemHandler.getSlotAPI(),
						indexInSlot: sourceDataItemHandler.indexInSlot
					}
				}
			},
			//TargetInfo (as defined in DnDSlotItemHandler)
			this.getDropTargetInfo(addAfter));
		}

		/**
   * @returns A11YData in the form that the provider needs to call insert.
   */

	}, {
		key: 'onDropA11Y',
		value: function onDropA11Y(addAfter) {
			var target = this.getDropTargetInfo(addAfter);
			this.visDnD.onDrop({ type: 'A11YMetadataColumns' }, target);
		}

		//A generic handler where data is expected to be in the form built for drag and drop.

	}, {
		key: 'onDrop',
		value: function onDrop(source, target) {
			//The only one we support locally for onDrop is slot sources.
			if (source.data.source) {
				// If we are swapping onto same item, we are done
				if (source.data.source.slot === this.getSlotAPI() && source.data.source.indexInSlot == this.indexInSlot) {
					return;
				}
				var sourceSlot = source.data.source.slot;
				var sourceIndex = source.data.source.indexInSlot;
				var addAfter = target.info.addAfter;
				var transactionToken = this.transactionApi.startTransaction();
				var sourceDataItem = sourceSlot.getDataItemList()[sourceIndex];
				var thisDataItem = this.slot.getDataItemList()[this.indexInSlot];
				var thisDataItemUniqueId = thisDataItem && thisDataItem.getId();

				if (sourceSlot.getId() === this.slotId) {
					// Handle swapping items within the same slot
					this._swapItemsInTheSameSlot(sourceDataItem.getId(), thisDataItemUniqueId, addAfter, transactionToken);
				} else if (addAfter || !thisDataItem) {
					this._moveItemToSlot(sourceSlot, sourceDataItem, addAfter, transactionToken);
				} else {
					this._swapItemsBetweenSlots(sourceSlot, sourceDataItem.getId(), thisDataItemUniqueId, transactionToken);
				}
				this.transactionApi.endTransaction(transactionToken);
			}
		}
	}, {
		key: '_swapItemsInTheSameSlot',
		value: function _swapItemsInTheSameSlot(sourceItemUniqueId, targetItemUniqueId, addAfter, transactionToken) {
			var dataItemRefs = this.slot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});

			var sourceIndex = dataItemRefs.indexOf(sourceItemUniqueId);
			var targetIndex = dataItemRefs.indexOf(targetItemUniqueId);

			if (addAfter || targetIndex === -1) {
				dataItemRefs.splice(targetIndex + 1, 0, sourceItemUniqueId);
				sourceIndex = sourceIndex > targetIndex ? sourceIndex + 1 : sourceIndex;
				dataItemRefs.splice(sourceIndex, 1);
			} else {
				dataItemRefs[sourceIndex] = targetItemUniqueId;
				dataItemRefs[targetIndex] = sourceItemUniqueId;
			}
			this.visualization.getSlots().setDataItems(dataItemRefs, this.slotId, transactionToken);
		}

		//A user moves an item to a new slot to 'add it after' something.
		//(either the another item or the slot heading).

	}, {
		key: '_moveItemToSlot',
		value: function _moveItemToSlot(sourceSlot, sourceDataItem, addAfter, transactionToken) {
			var sourceDataItemId = sourceDataItem.getId();
			var targetDataItemRefs = this.slot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});
			var targetIndex = this._getTargetIndex(addAfter);
			// Add this data item to the new slot
			targetDataItemRefs.splice(targetIndex, 0, sourceDataItemId);
			this.visualization.getSlots().setDataItems(targetDataItemRefs, this.slotId, transactionToken);
		}

		//This is the case where a user takes a slot and drops it on top of another slot (the two should swap)

	}, {
		key: '_swapItemsBetweenSlots',
		value: function _swapItemsBetweenSlots(sourceSlot, sourceDataItemUniqueId, targetDataItemUniqueId, transactionToken) {
			// Update target slot
			var targetSlotId = this.slotId;
			var targetDataItemRefs = this.slot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});
			var targetIndex = targetDataItemRefs.indexOf(targetDataItemUniqueId);
			targetDataItemRefs[targetIndex] = sourceDataItemUniqueId;

			// Update source slot
			var sourceSlotId = sourceSlot.getDefinition().getId();
			var sourceDataItemRefs = sourceSlot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});
			var sourceIndex = sourceDataItemRefs.indexOf(sourceDataItemUniqueId);
			sourceDataItemRefs[sourceIndex] = targetDataItemUniqueId;

			// swap
			this.visualization.getSlots().setDataItems(targetDataItemRefs, targetSlotId, transactionToken);
			this.visualization.getSlots().setDataItems(sourceDataItemRefs, sourceSlotId, transactionToken);
		}

		/**
   * @returns the actions associated with this dataItem and slotType
   */

	}, {
		key: 'getActions',
		value: function getActions() {
			var slots = this.slot.getDataItemList();
			var singleSlot = this._getSingleSlot(slots, this.indexInSlot);
			var slotActions = this.visualization.getSlots().getSlot(this.slotId).getDefinition().getProperty('actions');
			var actionExt = singleSlot ? slotActions : null;
			var options = {};
			if (actionExt && actionExt.length > 0) {
				options.actionsToKeep = actionExt;
			}
			return Promise.resolve(this._getActions(this.slotId, this.indexInSlot, options).map(function (action) {
				return _extends({
					text: action.label
				}, action);
			}));
		}

		/**
   * Brings up the UI to execute the slot action menu.
   * @param parentNode - the node to set the menu under.
   * @param editorOptions - an object to control things like placement of the menu.
   */

	}, {
		key: 'openSlotActionMenu',
		value: function openSlotActionMenu(parentNode, editorOptions) {
			var _this = this;

			return this.getActions().then(function (actions) {
				var actionList = actions.map(function (action) {
					return _extends({
						order: action.order || ActionTypes[action.name]
					}, action);
				}).sort(function (a, b) {
					return a.order - b.order;
				});
				_this._toolbarHelper.buildActionToolbar(actionList, parentNode, /*label*/null, editorOptions);
				return actionList;
			});
		}

		/* check if action menu is open */

	}, {
		key: 'isSlotActionMenuOpened',
		value: function isSlotActionMenuOpened() {
			return this._toolbarHelper.getToolbar() ? true : false;
		}
	}, {
		key: '_getSingleSlot',
		value: function _getSingleSlot(slots, mapIndex) {
			//if slots length is not 1, return null
			//if mapIndex exists and its an array of length > 1, return null
			var isArrayOfMapIndex = mapIndex && mapIndex instanceof Array && mapIndex.length > 1;
			if (slots.length !== 1 || isArrayOfMapIndex) {
				return null;
			}
			return slots[0];
		}
		/**
   * Set the index in the slot for a data item
   * @param {int} indexInSlot
   */

	}, {
		key: 'setIndexInSlot',
		value: function setIndexInSlot(indexInSlot) {
			this.indexInSlot = indexInSlot;
		}
	}, {
		key: 'getPickTreeContext',
		value: function getPickTreeContext(includeMetadata) {
			var context = {
				type: this.slot.getDefinition().getType()
			};
			if (includeMetadata && this.indexInSlot > -1) {
				context.metadataColumn = this.slot.getDataItemList()[this.indexInSlot].getMetadataColumn();
			}
			return context;
		}
	}]);

	return VisSlotDataItemHandler;
}();

exports.default = VisSlotDataItemHandler;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_73__;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_74__;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_75__;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(3);

var _FilterActionHandler = __webpack_require__(77);

var _FilterActionHandler2 = _interopRequireDefault(_FilterActionHandler);

var _DeleteFilterAction = __webpack_require__(80);

var _DeleteFilterAction2 = _interopRequireDefault(_DeleteFilterAction);

var _EditFilterAction = __webpack_require__(23);

var _EditFilterAction2 = _interopRequireDefault(_EditFilterAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
exports.default = _mobxStateTree.types.model('LocalFiltersModel', {
	localFilters: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.frozen()), [])
}).volatile(function () {
	return {
		content: null,
		dashboardApi: null,
		filterActionHandler: null
	};
}).views(function (self) {
	return {
		getLocalFilters: function getLocalFilters() {
			return self.localFilters;
		},
		getFilterActionHandler: function getFilterActionHandler() {
			if (!self.content || !self.dashboardApi) {
				return null;
			}
			if (!self.filterActionHandler) {
				var cbGetActionsForFilter = self.getActionsForLocalFilter.bind(self);
				self.setFilterActionHandler(new _FilterActionHandler2.default({
					dashboard: self.dashboardApi,
					content: self.content,
					cbGetActionsForFilter: cbGetActionsForFilter
				}));
			}
			return self.filterActionHandler;
		},
		getActionsForLocalFilter: function getActionsForLocalFilter(metadataColumn, filterId, itemId) {

			var availableActions = [];
			if (metadataColumn) {
				var editFilterAction = new _EditFilterAction2.default(self.dashboardApi, self.content, metadataColumn, filterId);
				if (editFilterAction.isEnabled()) {
					availableActions.push(editFilterAction);
				}
			}
			availableActions.push(new _DeleteFilterAction2.default(self.dashboardApi, self.content, metadataColumn, filterId, itemId));

			return Promise.resolve(availableActions);
		}
	};
}).actions(function (self) {
	var eventCallback = null;
	return {
		beforeDestroy: function beforeDestroy() {
			self.clearEvents();
		},
		setContent: function setContent(content) {
			self.content = content;
		},
		setUpEvents: function setUpEvents(callback) {
			if (self.content) {
				eventCallback = callback;
				self.content.on('change:visualization:localFilters:add', eventCallback);
				self.content.on('change:visualization:localFilters:edit', eventCallback);
				self.content.on('change:visualization:localFilters:remove', eventCallback);
			}
		},
		setDashboardApi: function setDashboardApi(dashboardApi) {
			self.dashboardApi = dashboardApi;
		},
		setFilterActionHandler: function setFilterActionHandler(filterActionHandler) {
			self.filterActionHandler = filterActionHandler;
		},
		setLocalFilters: function setLocalFilters() {
			var localFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			self.localFilters = localFilters;
		},
		clear: function clear() {
			self.clearEvents();
			self.content = null;
			self.localFilters = [];
			self.filterActionHandler = null;
		},
		clearEvents: function clearEvents() {
			if (self.content) {
				self.content.off('change:visualization:localFilters:add', eventCallback);
				self.content.off('change:visualization:localFilters:edit', eventCallback);
				self.content.off('change:visualization:localFilters:remove', eventCallback);
				eventCallback = null;
			}
		}
	};
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| (C) Copyright IBM Corp. 2019, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

var _ToolbarHelper = __webpack_require__(16);

var _ToolbarHelper2 = _interopRequireDefault(_ToolbarHelper);

var _LocalFilterDialog = __webpack_require__(78);

var _LocalFilterDialog2 = _interopRequireDefault(_LocalFilterDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterActionHandler = function () {

	/**
  * FilterActionHandler is a collection of api's that allow easy editing of local filters via a filter dialog
  *
  * @param {Object} attributes
  * @param {DashboardAPI} attributes.dashboard - dashboard API
  * @param {ContentAPI} attributes.content - content API
  * @param {Function} [attributes.cbOnRemove] - callback to be called when the editor is removed
  * @param {Function} attributes.cbGetActionsForFilter - callback to be called to get the actions
  */
	function FilterActionHandler(attributes) {
		_classCallCheck(this, FilterActionHandler);

		this.dashboard = attributes.dashboard;
		this.content = attributes.content;
		this._cbOnRemove = attributes.cbOnRemove || this._cbOnRemove;
		this._getActions = attributes.cbGetActionsForFilter;

		this.visualization = this.content.getFeature('Visualization');
		this.visDnD = this.content.getFeature('VisDnD');
		this.localFilters = this.visualization.getLocalFilters();
		this.slots = this.visualization.getSlots();

		// TODO: Local filter dialog class needs to be refactored
		this.localFilterDialog = new _LocalFilterDialog2.default({
			dashboard: this.dashboard,
			content: this.content
		});

		this._toolbarHelper = new _ToolbarHelper2.default();
	}

	_createClass(FilterActionHandler, [{
		key: 'getDatasourceId',
		value: function getDatasourceId() {
			var dataSource = this.visualization.getDataSource();
			if (dataSource) {
				return dataSource.getId();
			}
			return null;
		}

		/**
   * editLocalFilters is called to create a dialog in scenarios such as when a data item is dropped in the Context Filters section when editing slots.
   * @param {Object} droppedColumns - the structure contains information of the columns dropped in the local filter slot (MetadataDnDResults object)
   * @param {Object} localFiltersDomNode - a domNode which is used to place the editor.
   * @param {Object} editorOptions - further options
   *			1) placement - placement overrides (eg auto)
   *			2) forceOpen - when false, a filter entry can be replaced without launching the UI.
  */

	}, {
		key: 'editLocalFilters',
		value: function editLocalFilters(droppedColumns, localFiltersDomNode, editorOptions) {

			var metadataColumns = _underscore2.default.map(droppedColumns && droppedColumns.columns, function (column) {
				return column.metadataColumn;
			});

			if (metadataColumns.length > 0) {
				var transactionApi = this.dashboard.getFeature('Transaction');
				var transactionToken = transactionApi.startTransaction();

				var firstMetadataColumn = metadataColumns[0];
				var sourceId = firstMetadataColumn.getSourceId();
				if (sourceId) {
					this.visualization.setDataSource(sourceId, transactionToken);
				}

				// add columns of member type first
				var columnsWithMembers = droppedColumns.utils.getColumnsWithMembers(true /* filterMemberColumns */);
				var columnIds = Object.keys(columnsWithMembers);
				if (columnIds.length) {
					this.content.getFeature('VisDnD.utils').addMembersAsLocalFilters({ visualizationAPI: this.visualization, columns: droppedColumns.columns }, transactionToken);
					// remove these columns from metadataColumns
					metadataColumns = metadataColumns.filter(function (column) {
						return !columnIds.includes(column.getId());
					});
				}

				// then add columns of type model filters
				var modelFilters = metadataColumns.filter(function (column) {
					return column.isFilter();
				});
				if (modelFilters.length) {
					var modelFilterIds = modelFilters.map(function (column) {
						return column.getId();
					});
					this._addModelFilters(modelFilterIds, transactionToken);
					metadataColumns = metadataColumns.filter(function (column) {
						return !modelFilterIds.includes(column.getId());
					});
				}
				// then display filter dialog to add filters for columns of type query item
				if (metadataColumns.length) {
					// we don't support for now multiple rendering of filter dialog, so just render dialog of the 1st query item
					var column = metadataColumns[0];
					this.localFilterDialog.renderDialog(column.getId(), localFiltersDomNode, editorOptions);
				}
				transactionApi.endTransaction(transactionToken);
			}
		}
	}, {
		key: 'insertItemFromTypeInSlot',
		value: function insertItemFromTypeInSlot(metadataColumn, sourceId, options) {
			var localFilterSelector = '.slotEditor__localFilters';
			var itemId = metadataColumn.getId();
			var localFiltersDomNode = options.parentNode || document.querySelector(localFilterSelector);
			var transactionApi = this.dashboard.getFeature('Transaction');
			var transactionToken = transactionApi.startTransaction();
			if (sourceId) {
				this.visualization.setDataSource(sourceId, transactionToken);
			}
			var defaultEditorOptions = {
				placement: 'bottom',
				attachPoint: localFilterSelector + '__attachPoint'
			};
			if (metadataColumn.isFilter()) {
				this._addModelFilters([itemId], transactionToken);
			} else {
				var editorOptions = options.editorOptions || defaultEditorOptions;
				this.localFilterDialog.renderDialog(itemId, localFiltersDomNode, editorOptions);
			}
			transactionApi.endTransaction(transactionToken);
		}

		/**
   * This method adds dropped columns of type "model filter" in the local filters
   * @param modelFilterIds - list of model filter identifiers (metadataColumn.getId()) to add in local filters
   * @param transactionToken - transaction token for the action
  */

	}, {
		key: '_addModelFilters',
		value: function _addModelFilters(modelFilterIds, transactionToken) {
			var localFilters = this.visualization.getLocalFilters();
			modelFilterIds.forEach(function (filterId) {
				var itemContext = {
					id: filterId,
					itemId: filterId,
					filterType: 'filter'
				};
				localFilters.addFilter(itemContext, {} /* filterContext */, transactionToken);
			});
		}
	}, {
		key: 'getContentId',
		value: function getContentId() {
			return this.content.getId();
		}

		/**
   * @returns the actions associated with this metadataColumn and filterId
   */

	}, {
		key: 'getActions',
		value: function getActions(metadataColumn, filterId, itemId) {
			return this._getActions(metadataColumn, filterId, itemId);
		}
	}, {
		key: 'openFilterItemActionMenu',
		value: function openFilterItemActionMenu(filterInfo, parentNode, editorOptions) {
			var _this = this;

			var dataSource = this.visualization.getDataSource();
			if (!dataSource) {
				return Promise.resolve([]);
			}
			var metadataColumn = dataSource.getMetadataColumn(filterInfo.columnId);
			var filterId = filterInfo.filterId;
			return this.getActions(metadataColumn, filterId, filterInfo.columnId).then(function (actions) {
				var aActions = [];
				_underscore2.default.each(actions, function (action) {
					aActions = aActions.concat(action.getAvailableActions());
				});

				aActions.sort(function (a, b) {
					return a.order - b.order;
				});

				_this._toolbarHelper.buildActionToolbar(aActions, parentNode, /*label*/null, editorOptions);
				return actions;
			});
		}

		/* check if action menu is open */

	}, {
		key: 'isFilterActionMenuOpened',
		value: function isFilterActionMenuOpened() {
			return this._toolbarHelper.getToolbar() ? true : false;
		}
	}, {
		key: 'getDropTargetInfo',
		value: function getDropTargetInfo(node) {
			var dropTargetInfo = {
				type: 'slot.filter',
				info: {
					contentId: this.getContentId(),
					node: node,
					slotDataItemHandler: this
				}
			};
			return dropTargetInfo;
		}
	}, {
		key: 'onDropA11Y',
		value: function onDropA11Y(node) {
			var target = this.getDropTargetInfo(node);
			this.visDnD.onDrop({ type: 'A11YMetadataColumns' }, target);
		}
	}, {
		key: 'getPickTreeContext',
		value: function getPickTreeContext() {
			return {
				type: 'localfilters'
			};
		}
	}]);

	return FilterActionHandler;
}();

exports.default = FilterActionHandler;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ToolbarHelper = __webpack_require__(16);

var _ToolbarHelper2 = _interopRequireDefault(_ToolbarHelper);

var _EditFilterAction = __webpack_require__(23);

var _EditFilterAction2 = _interopRequireDefault(_EditFilterAction);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// -----TEMPORARY-------
// TODO: needs to be removed when we slightly refactor the slot actions returning
// dashboard-analytics paths like so: `dashboard-analytics/dialogs/CommonViewWrapper`
// that are eventually loaded by NextView.js
var DynamicFileLoader = __webpack_require__(79);
// ---------------------

var LocalFilterDialog = function () {
	function LocalFilterDialog(options) {
		_classCallCheck(this, LocalFilterDialog);

		this._toolbarHelper = new _ToolbarHelper2.default();
		this.dashboard = options.dashboard;
		this.content = options.content;
	}

	_createClass(LocalFilterDialog, [{
		key: 'renderDialog',
		value: function renderDialog(metadataColumnId, renderNode, editorOptions) {
			var _this = this;

			var visualization = this.content.getFeature('Visualization');
			var metadataColumn = visualization.getDataSource().getMetadataColumn(metadataColumnId);
			var fAction = new _EditFilterAction2.default(this.dashboard, this.content, metadataColumn);

			if (!editorOptions.forceOpen && metadataColumn.isNamedSet()) {
				var localFilters = visualization.getLocalFilters();
				localFilters.addFilter(fAction.itemContext, {
					command: 'replace',
					exclude: false,
					valueDataItem: metadataColumn.getId(),
					type: metadataColumn.isProperty() ? 'display' : undefined
				});
			} else {
				var sDialogModule = fAction.getEditorModuleName();
				var viewOptions = fAction.getViewOptions();

				return DynamicFileLoader.load([sDialogModule]).then(function (modules) {
					return new modules[0](viewOptions);
				}).then(function (view) {
					var preloadDone = _this.preload && _this.preload() || (view.preload ? view.preload() : Promise.resolve()); // required for unit tests
					return preloadDone.then(_this._createContextFilter.bind(_this, view, renderNode, editorOptions)).then(function () {
						return view.renderCallBack(_this._toolbarHelper.getToolbar());
					});
				});
			}
		}
	}, {
		key: '_createContextFilter',
		value: function _createContextFilter(view, parentNode, editorOptions) {
			var actions = [{
				name: 'subview',
				responsive: false,
				editable: false,
				changedAction: null,
				subView: view,
				type: 'SubView'
			}];

			// We need to send the popoverContentClass along when creating the toolbar
			// So popovers are sized and positioned correctly
			// Defect #205657, #208527; APAR #123258;
			editorOptions.popoverContentClass = view.$el && view.$el.attr('class');

			this._toolbarHelper.buildActionToolbar(actions, parentNode, _StringResources2.default.get('toolbarActionFilter'), editorOptions);
		}
	}, {
		key: 'getAPI',
		value: function getAPI() {
			return this.api;
		}
	}]);

	return LocalFilterDialog;
}();

exports.default = LocalFilterDialog;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_79__;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ACTION_ID = 'deleteFilterAction';

var DeleteFilterAction = function () {

	/**
  * Constructor
  *
  * @param dashboard - dashboard API
  * @param content - content API of the current visualization of interest
  * @param metadataColumn - The metadataColumn this filter to be deleted.
  * @param filterId (optional) - The uniqueId of the filter to be deleted.
  */
	function DeleteFilterAction(dashboard, content, metadataColumn, filterId, itemId) {
		_classCallCheck(this, DeleteFilterAction);

		this.content = content;
		this.dashboard = dashboard;
		this.metadataColumn = metadataColumn;
		this.filterId = filterId;
		this.itemId = itemId;

		this.transactionApi = dashboard.getFeature('Transaction');
		this.localFilters = this.content.getFeature('Visualization').getLocalFilters();

		this.toolbarContribution = [{
			name: 'delete',
			text: _StringResources2.default.get('toolbarDeleteFilterActionText'),
			label: _StringResources2.default.get('toolbarDeleteFilterActionText'),
			icon: 'dashboard-delete',
			type: 'Button',
			removeOnActionApplied: true,
			action: this.deleteLocalFilter.bind(this),
			group: ACTION_ID
		}];
	}

	/**
  * This method will return the action id for this action (such as aggregationTypeAction, sortAction, etc....)
  * @returns action id - a string describing this particular action.
  */


	_createClass(DeleteFilterAction, [{
		key: 'getActionId',
		value: function getActionId() {
			return ACTION_ID;
		}

		/**
   * get the set of availableSort actions setting the selected state to match
   * the state of the data.
   * @returns the sort actions and their state.
   */

	}, {
		key: 'getAvailableActions',
		value: function getAvailableActions() {
			return this.toolbarContribution;
		}

		/**
   * Delete the filter defined in the filterId attribute or by metadataColumn.
   * Delete by filterId allows support for 'AdditionalFilters' (ie: multiple keeps/excludes on the same item).
   */

	}, {
		key: 'deleteLocalFilter',
		value: function deleteLocalFilter() {
			var filterKey = this.filterId ? {
				id: this.filterId
			} : this._getFilterKeyFromMetadataColumn();

			if (filterKey) {
				if (this.metadataColumn && this.metadataColumn.getType() === 'fact') {
					filterKey.itemId = this.metadataColumn.getId();
					filterKey.aggregationType = this.metadataColumn.getDefaultAggregation();
				} else {
					//The new removeFilter API uses 'itemId' as the filter key
					filterKey.itemId = this.itemId || filterKey.id;
				}

				if (this.metadataColumn && this.metadataColumn.isFilter()) {
					filterKey.filterType = 'filter';
				}

				var transactionToken = this.transactionApi.startTransaction();
				this.localFilters.removeFilter(filterKey, transactionToken);
				this.transactionApi.endTransaction(transactionToken);
			}
		}

		//When using metadataColumn, delete the first filter with this columnId and aggregation type.
		//TODO: Kept for backwards compatibility.  Delete by columnId is likely deprecated.

	}, {
		key: '_getFilterKeyFromMetadataColumn',
		value: function _getFilterKeyFromMetadataColumn() {
			var filterToDelete = this.metadataColumn.getId();
			if (filterToDelete) {
				if (this.metadataColumn.getType() === 'fact') {
					return this.localFilters.getOrdinalFilterKey( /*itemId*/filterToDelete, this.metadataColumn.getDefaultAggregation());
				} else {
					return this.localFilters.getCategoryFilterKey( /*itemId*/filterToDelete);
				}
			}
			return null;
		}
	}]);

	return DeleteFilterAction;
}();

exports.default = DeleteFilterAction;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,c){if(true)module.exports=c(__webpack_require__(10));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],c);else{var s=c("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in s)("object"==typeof exports?exports:e)[a]=s[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([585],{"6873601dfe1d9459c1a9":function(c,s){c.exports=e},"7f5cc0d1af315e161ce4":function(e,c,s){"use strict";var a=s("9689a9c94ae38b47fa2c"),o=s.n(a),i=s("9ce58a7deea14f49ef01"),n=s.n(i),t=new o.a({id:"refined_24_v7",use:"refined_24_v7-usage",viewBox:"0 0 24 24",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="refined_24_v7"><path d="M1.5,10.5v3C1.5,14.3,2.2,15,3,15h18c0.8,0,1.5-0.7,1.5-1.5v-3C22.5,9.7,21.8,9,21,9H3C2.2,9,1.5,9.7,1.5,10.5z M1.5,3v3\tc0,0.8,0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5V3c0-0.8-0.7-1.5-1.5-1.5H3C2.2,1.5,1.5,2.2,1.5,3z M7.5,6H3V3h4.5V6z M21,6H9V3h12\tV6z M22.5,21v-3c0-0.8-0.7-1.5-1.5-1.5H3c-0.8,0-1.5,0.7-1.5,1.5v3c0,0.8,0.7,1.5,1.5,1.5h18C21.8,22.5,22.5,21.8,22.5,21z M16.5,18\tH21v3h-4.5V18z M3,18h12v3H3V18z" /></symbol>'});n.a.add(t);c.a=t},a91ca1782d8252e7ef1b:function(e,c,s){"use strict";Object.defineProperty(c,"__esModule",{value:!0});var a=s("6873601dfe1d9459c1a9"),o=(s.n(a),s("7f5cc0d1af315e161ce4"));c.default=o.a}},["a91ca1782d8252e7ef1b"])});

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_82__;

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// SlotEditorState.js